// Arabic translations, keyed by the English source string (see ./index.js).
//
// Terminology used throughout: Captain = كابتن, Restaurant = مطعم, Order = طلب, Trip = رحلة,
// District = حي, Zone = منطقة, City = مدينة, Governorate = محافظة, Bundle = باقة,
// Wallet = محفظة, Top-up = شحن رصيد, Dispatch = توزيع الطلبات, Stacking = تجميع الطلبات,
// EGP = ج.م. Keep new entries consistent with these.
//
// Not translated on purpose: the template's demo pages (colors/typography/shadows samples,
// lorem ipsum, fake notifications) — they fall back to English.

const ar = {
  // ---------------------------------------------------------------- common actions & words
  Actions: 'الإجراءات',
  Add: 'إضافة',
  'Add {item}': 'إضافة {item}',
  'Edit {item}': 'تعديل {item}',
  'Delete {item}?': 'حذف {item}؟',
  '{item} created successfully': 'تمت إضافة {item} بنجاح',
  '{item} updated successfully': 'تم تحديث {item} بنجاح',
  '{item} deleted successfully': 'تم حذف {item} بنجاح',
  '{field} is required': '{field} مطلوب',
  'Search {items}...': 'بحث في {items}...',
  Added: 'تمت الإضافة',
  'Adding…': 'جارٍ الإضافة…',
  Apply: 'تطبيق',
  'Apply {count}': 'تطبيق {count}',
  'Applying…': 'جارٍ التطبيق…',
  Approve: 'قبول',
  'Approving…': 'جارٍ القبول…',
  Back: 'رجوع',
  Block: 'حظر',
  Blocked: 'محظور',
  Cancel: 'إلغاء',
  'Cancelling…': 'جارٍ الإلغاء…',
  'Change Image': 'تغيير الصورة',
  Clear: 'مسح',
  Close: 'إغلاق',
  'Confirm Reject': 'تأكيد الرفض',
  'Creating…': 'جارٍ الإنشاء…',
  Delete: 'حذف',
  'Deleting…': 'جارٍ الحذف…',
  Details: 'التفاصيل',
  Download: 'تحميل',
  Edit: 'تعديل',
  Insert: 'إدراج',
  'Inserting…': 'جارٍ الإدراج…',
  Lift: 'رفع',
  'Locating…': 'جارٍ تحديد الموقع…',
  'Looking up…': 'جارٍ البحث…',
  Lookup: 'بحث',
  No: 'لا',
  'No records found': 'لا توجد سجلات',
  'Processing…': 'جارٍ المعالجة…',
  Read: 'مقروء',
  Unread: 'غير مقروء',
  Refresh: 'تحديث',
  'Refresh now': 'تحديث الآن',
  Reject: 'رفض',
  'Rejecting…': 'جارٍ الرفض…',
  Remove: 'إزالة',
  Request: 'طلب',
  'Requesting…': 'جارٍ الطلب…',
  'Resetting…': 'جارٍ إعادة التعيين…',
  Save: 'حفظ',
  'Saving…': 'جارٍ الحفظ…',
  Search: 'بحث',
  'Search…': 'بحث…',
  'No matches': 'لا توجد نتائج',
  'Alternative names': 'الأسماء البديلة',
  'Add alternative name': 'إضافة اسم بديل',
  All: 'الكل',
  'Show captains': 'إظهار الكباتن',
  'Show restaurants': 'إظهار المطاعم',
  'Orders waiting for a captain': 'طلبات بانتظار كابتن',
  'Late orders': 'الطلبات المتأخرة',
  'No late orders': 'لا توجد طلبات متأخرة',
  'Not picked up': 'لم يُستلم',
  'Not delivered': 'لم يُسلَّم',
  'Late by': 'مدة التأخير',
  'No captain': 'بدون كابتن',
  'Past the preparation time and not picked up, or past the restaurant’s deadline and not delivered. Open an order to act on it.': 'تجاوزت وقت التحضير ولم تُستلم، أو تجاوزت المهلة المحددة للمطعم ولم تُسلَّم. افتح الطلب لاتخاذ إجراء.',
  'On Hold': 'معلّق',
  Destination: 'الوجهة',
  'Offered to': 'معروض على',
  Waiting: 'مدة الانتظار',
  'No orders are waiting for a captain': 'لا توجد طلبات بانتظار كابتن',
  '{minutes} min': '{minutes} دقيقة',
  '{hours} h {minutes} min': '{hours} ساعة {minutes} دقيقة',
  '{days} days': '{days} يوم',
  'Only receive orders from restaurants in their working zone': 'يستقبل طلبات مطاعم منطقة عمله فقط',
  'Request Fee Percent (%) — blank or 0 = platform App Fee': 'نسبة عمولة الطلب (%) — فارغ أو 0 = عمولة التطبيق من إعدادات المنصة',
  'Zone locked': 'مقيد بمنطقته',
  'Max Orders Per Captain — blank = platform setting': 'الحد الأقصى للطلبات للكابتن — فارغ = إعداد المنصة',
  'Request Fee %': 'نسبة العمولة',
  'App Fee': 'عمولة التطبيق',
  'No zone': 'بدون منطقة',
  'All zones': 'كل المناطق',
  'Searching…': 'جارٍ البحث…',
  Send: 'إرسال',
  'Sending…': 'جارٍ الإرسال…',
  Sent: 'مُرسل',
  'This action cannot be undone.': 'لا يمكن التراجع عن هذا الإجراء.',
  Unblock: 'إلغاء الحظر',
  Upload: 'رفع',
  'Upload Image': 'رفع صورة',
  'Uploading…': 'جارٍ الرفع…',
  Verify: 'توثيق',
  'Verifying…': 'جارٍ التوثيق…',
  'View All': 'عرض الكل',
  'View details': 'عرض التفاصيل',
  'View Details': 'عرض التفاصيل',
  Yes: 'نعم',
  'Must be valid JSON': 'يجب أن يكون JSON صالحًا',

  // ---------------------------------------------------------------- generic errors
  'Action failed': 'فشل الإجراء',
  'Adjustment failed': 'فشلت التسوية',
  'Approval failed': 'فشل القبول',
  'Bundle request failed': 'فشل طلب الباقة',
  'Cancel failed': 'فشل الإلغاء',
  'Cancellation failed': 'فشل الإلغاء',
  'Create failed': 'فشل الإنشاء',
  'Delete failed': 'فشل الحذف',
  'Download failed': 'فشل التحميل',
  'Failed to add fee': 'فشلت إضافة الرسوم',
  'Failed to add phone': 'فشلت إضافة الرقم',
  'Failed to add to blacklist': 'فشلت الإضافة إلى قائمة الحظر',
  'Failed to assign district': 'فشل تعيين الحي',
  'Failed to create order': 'فشل إنشاء الطلب',
  'Failed to delete': 'فشل الحذف',
  'Failed to end wait': 'فشل إنهاء الانتظار',
  'Failed to load app releases': 'فشل تحميل إصدارات التطبيق',
  'Failed to load blacklist': 'فشل تحميل قائمة الحظر',
  'Failed to load boundary': 'فشل تحميل الحدود',
  'Failed to load branches': 'فشل تحميل الفروع',
  'Failed to load bundle history': 'فشل تحميل سجل الباقات',
  'Failed to load bundle requests': 'فشل تحميل طلبات الباقات',
  'Failed to load bundle usage': 'فشل تحميل استخدام الباقات',
  'Failed to load captains': 'فشل تحميل الكباتن',
  'Failed to load dashboard data': 'فشل تحميل بيانات لوحة التحكم',
  'Failed to load data': 'فشل تحميل البيانات',
  'Failed to load delivery restrictions': 'فشل تحميل قيود التوصيل',
  'Failed to load district connections': 'فشل تحميل روابط الأحياء',
  'Failed to load district polygons': 'فشل تحميل حدود الأحياء',
  'Failed to load districts': 'فشل تحميل الأحياء',
  'Failed to load eligible captains': 'فشل تحميل الكباتن المؤهلين',
  'Failed to load fees': 'فشل تحميل الرسوم',
  'Failed to load live tracking data': 'فشل تحميل بيانات التتبع المباشر',
  'Failed to load notifications': 'فشل تحميل الإشعارات',
  'Failed to load order': 'فشل تحميل الطلب',
  'Failed to load orders': 'فشل تحميل الطلبات',
  'Failed to load phones': 'فشل تحميل الأرقام',
  'Failed to load platform settings': 'فشل تحميل إعدادات المنصة',
  'Failed to load registration requests': 'فشل تحميل طلبات التسجيل',
  'Failed to load restaurants/districts/zones for the picker': 'فشل تحميل المطاعم/الأحياء/المناطق للاختيار',
  'Failed to load restriction': 'فشل تحميل القيد',
  'Failed to load top-up requests': 'فشل تحميل طلبات شحن الرصيد',
  'Failed to load trip': 'فشل تحميل الرحلة',
  'Failed to load trips': 'فشل تحميل الرحلات',
  'Failed to load wallet': 'فشل تحميل المحفظة',
  'Failed to load wallets': 'فشل تحميل المحافظ',
  'Failed to remove fee': 'فشلت إزالة الرسوم',
  'Failed to remove from blacklist': 'فشلت الإزالة من قائمة الحظر',
  'Failed to remove phone': 'فشلت إزالة الرقم',
  'Failed to save the label': 'فشل حفظ الوصف',
  'Failed to set sequence number': 'فشل تعيين رقم التسلسل',
  'Failed to update fee': 'فشل تحديث الرسوم',
  'Failed to update payment status': 'فشل تحديث حالة الدفع',
  'Failed to update phone': 'فشل تحديث الرقم',
  'Insert failed': 'فشل الإدراج',
  'Lookup failed': 'فشل البحث',
  'Password reset failed': 'فشلت إعادة تعيين كلمة المرور',
  'Reassign failed': 'فشلت إعادة التعيين',
  'Rejection failed': 'فشل الرفض',
  'Save failed': 'فشل الحفظ',
  'Search failed': 'فشل البحث',
  'Search failed — check your connection and try again': 'فشل البحث — تحقق من الاتصال وحاول مرة أخرى',
  'Send failed': 'فشل الإرسال',
  'Top-up failed': 'فشل شحن الرصيد',
  'Update failed': 'فشل التحديث',
  'Upload failed': 'فشل الرفع',
  'Verification failed': 'فشل التوثيق',

  // ---------------------------------------------------------------- validation
  'Must be a positive integer': 'يجب أن يكون عددًا صحيحًا موجبًا',
  'Must be a positive number': 'يجب أن يكون رقمًا موجبًا',
  'Must be a valid email': 'يجب إدخال بريد إلكتروني صالح',
  'Must be an integer between 1 and 10': 'يجب أن يكون عددًا صحيحًا بين 1 و10',
  'Must be an integer of at least 5': 'يجب أن يكون عددًا صحيحًا لا يقل عن 5',
  'Must be an integer between 10 and 600': 'يجب أن يكون عددًا صحيحًا بين 10 و600',
  'Must be between 0 and 100': 'يجب أن يكون بين 0 و100',
  'Must be zero or a positive integer': 'يجب أن يكون صفرًا أو عددًا صحيحًا موجبًا',
  'Must be zero or a positive number': 'يجب أن يكون صفرًا أو رقمًا موجبًا',
  'At least 8 characters': '8 أحرف على الأقل',

  // ---------------------------------------------------------------- units & small labels
  EGP: 'ج.م',
  km: 'كم',
  min: 'دقيقة',
  m: 'م',
  sec: 'ث',
  'min total': 'دقيقة إجمالًا',
  'km — source:': 'كم — المصدر:',
  '{count} hops': '{count} قفزات',
  '{minutes} min driving': '{minutes} دقيقة قيادة',
  'heads {direction} ({degrees}°)': 'الاتجاه {direction} ({degrees}°)',
  'Max {size} MB': 'الحد الأقصى {size} ميجابايت',
  'The file is larger than {size} MB': 'حجم الملف أكبر من {size} ميجابايت',
  ID: 'المعرّف',
  Name: 'الاسم',
  Status: 'الحالة',
  Type: 'النوع',
  type: 'النوع',
  Title: 'العنوان',
  Description: 'الوصف',
  'Description (HTML)': 'الوصف (HTML)',
  Notes: 'ملاحظات',
  Label: 'الوصف',
  'Label (optional)': 'الوصف (اختياري)',
  'Display Label': 'الاسم المعروض',
  Amount: 'المبلغ',
  'Amount (EGP)': 'المبلغ (ج.م)',
  Balance: 'الرصيد',
  'Balance After': 'الرصيد بعد العملية',
  Phone: 'الهاتف',
  Phones: 'أرقام الهاتف',
  Email: 'البريد الإلكتروني',
  Address: 'العنوان',
  Photo: 'الصورة',
  Logo: 'الشعار',
  'Logo URL (optional)': 'رابط الشعار (اختياري)',
  Size: 'الحجم',
  File: 'الملف',
  Slug: 'المعرّف النصي',
  'Slug (e.g. about-app)': 'المعرّف النصي (مثال: about-app)',
  Tag: 'الوسم',
  Source: 'المصدر',
  Reference: 'المرجع',
  Reason: 'السبب',
  'Reason (optional)': 'السبب (اختياري)',
  Reasons: 'الأسباب',
  Comment: 'التعليق',
  Rating: 'التقييم',
  Ratings: 'التقييمات',
  When: 'التاريخ',
  By: 'بواسطة',
  by: 'بواسطة',
  From: 'من',
  To: 'إلى',
  Direction: 'الاتجاه',
  Features: 'المميزات',
  Owner: 'المالك',
  Round: 'الجولة',
  Response: 'الاستجابة',
  Offered: 'وقت العرض',
  Requested: 'تاريخ الطلب',
  'Requested At': 'تاريخ الطلب',
  'Requested By': 'مقدم الطلب',
  Created: 'تاريخ الإنشاء',
  'Created On': 'تاريخ الإنشاء',
  Updated: 'آخر تحديث',
  'Updated {time}': 'آخر تحديث {time}',
  'Last updated': 'آخر تحديث',
  Started: 'تاريخ البدء',
  Completed: 'تاريخ الاكتمال',
  Uploaded: 'تاريخ الرفع',
  Enabled: 'مفعّل',
  Disabled: 'معطّل',
  Active: 'نشط',
  Inactive: 'غير نشط',
  Verified: 'موثّق',
  Estimated: 'تقديري',
  Expired: 'منتهي',
  Frozen: 'مجمّد',
  Freeze: 'تجميد',
  Unfreeze: 'إلغاء التجميد',
  Deactivated: 'معطّل',
  Unlimited: 'غير محدود',
  'No expiry': 'بدون انتهاء',
  Pending: 'قيد الانتظار',
  Paid: 'مدفوع',
  Unpaid: 'غير مدفوع',
  Today: 'اليوم',
  Week: 'أسبوع',
  Month: 'شهر',
  'This Month': 'هذا الشهر',
  'This Year': 'هذا العام',
  Lat: 'خط العرض',
  Lon: 'خط الطول',
  Latitude: 'خط العرض',
  Longitude: 'خط الطول',
  Location: 'الموقع',
  'Last known location': 'آخر موقع معروف',
  Inside: 'داخل',
  Found: 'تم العثور على',
  Target: 'الهدف',
  Setting: 'الإعداد',
  Settings: 'الإعدادات',
  Content: 'المحتوى',
  App: 'التطبيق',
  Brand: 'العلامة التجارية',
  Role: 'الدور',
  Roles: 'الأدوار',
  Notification: 'إشعار',
  Notifications: 'الإشعارات',
  'Notification sent': 'تم إرسال الإشعار',
  Recipient: 'المستلم',
  'Recipient Type': 'نوع المستلم',
  History: 'السجل',
  'Mark as all read': 'تحديد الكل كمقروء',
  Profile: 'الملف الشخصي',
  Logout: 'تسجيل الخروج',
  'Account Settings': 'إعدادات الحساب',
  Support: 'الدعم',
  Feedback: 'الملاحظات',
  'Privacy Center': 'مركز الخصوصية',
  'Ctrl + K': 'Ctrl + K',
  'open drawer': 'فتح القائمة',
  'open more menu': 'فتح المزيد',
  'open profile': 'فتح الملف الشخصي',
  'profile tabs': 'تبويبات الملف الشخصي',
  'mailbox folders': 'القائمة الجانبية',
  'toggle password visibility': 'إظهار/إخفاء كلمة المرور',
  'Generate password': 'إنشاء كلمة مرور',

  // ---------------------------------------------------------------- navigation / menu groups
  Dashboard: 'لوحة التحكم',
  Navigation: 'التنقل',
  Geography: 'الجغرافيا',
  'Identity & Access': 'الهوية والصلاحيات',
  'Orders & Dispatch': 'الطلبات والتوزيع',
  'Finance & Wallets': 'المالية والمحافظ',
  Finance: 'المالية',
  Social: 'التواصل',
  Home: 'الرئيسية',
  Governorate: 'محافظة',
  Governorates: 'المحافظات',
  City: 'مدينة',
  Cities: 'المدن',
  'City ID': 'معرّف المدينة',
  Zone: 'منطقة',
  Zones: 'المناطق',
  'Zone #': 'منطقة #',
  District: 'حي',
  Districts: 'الأحياء',
  district: 'حي',
  'District ID': 'معرّف الحي',
  'District Polygons': 'حدود الأحياء',
  'District Distance Matrix': 'مصفوفة المسافات بين الأحياء',
  'Zone Distance Matrix': 'مصفوفة المسافات بين المناطق',
  'Zone Matrix': 'مصفوفة المناطق',
  'Zone route lookup': 'البحث عن مسار بين المناطق',
  'From zone': 'من منطقة',
  'To zone': 'إلى منطقة',
  'Zone route —': 'مسار المناطق —',
  'Duration (minutes)': 'المدة (دقيقة)',
  'Estimated (not measured yet)': 'تقديري (لم يُقَس بعد)',
  'These zones are not connected in the zone matrix yet — add the links between them below.':
    'هذه المناطق غير مرتبطة في مصفوفة المناطق بعد — أضف الروابط بينها بالأسفل.',
  "Travel time between districts in different zones is the sum of the links along the shortest chain of zones here. Districts in the same zone use the District Matrix. Link each zone to the zones it borders. Leave distance and duration blank to calculate them from the driving route between the two zones' centres (set each zone's centre on the Zones page), or enter them by hand. Switch on \"also create the reverse connection\" to add both directions.":
    'زمن الرحلة بين أحياء في مناطق مختلفة هو مجموع الروابط على أقصر سلسلة من المناطق هنا. أما الأحياء داخل نفس المنطقة فتستخدم مصفوفة الأحياء. اربط كل منطقة بالمناطق المجاورة لها. اترك المسافة والمدة فارغتين لحسابهما من مسار القيادة بين مركزي المنطقتين (حدّد مركز كل منطقة في صفحة المناطق)، أو أدخلهما يدويًا. فعّل "إنشاء الاتجاه العكسي أيضًا" لإضافة الاتجاهين.',
  'District Matrix': 'مصفوفة الأحياء',
  'Show Zone Graph': 'عرض شبكة المناطق',
  'Zone link': 'رابط بين منطقتين',
  'Failed to load the zone graph': 'تعذّر تحميل شبكة المناطق',
  'No zone matrix links between the shown zones yet — add some from the Zone Matrix page.':
    'لا توجد روابط بين المناطق المعروضة في مصفوفة المناطق بعد — أضفها من صفحة مصفوفة المناطق.',
  '{count} zone(s) have no centre set — set it on the Zones page to show them here.':
    '{count} منطقة بدون مركز — حدّده في صفحة المناطق لعرضها هنا.',
  '{count} district(s)': '{count} حي',
  'Zone centre': 'مركز المنطقة',
  'Distance (km) — leave blank to calculate from the zone centres': 'المسافة (كم) — اتركها فارغة لحسابها من مركزي المنطقتين',
  'Duration (minutes) — leave blank to calculate from the zone centres': 'المدة (دقيقة) — اتركها فارغة لحسابها من مركزي المنطقتين',
  'Distance Matrix': 'مصفوفة المسافات',
  'Delivery Restrictions': 'قيود التوصيل',
  'Staff User': 'موظف',
  'Staff Users': 'الموظفون',
  'Registration Request': 'طلب تسجيل',
  'Registration Requests': 'طلبات التسجيل',
  Captain: 'كابتن',
  Captains: 'الكباتن',
  captains: 'كباتن',
  'Captain Status': 'حالة الكابتن',
  'Captain Statuses': 'حالات الكباتن',
  'Live Tracking': 'التتبع المباشر',
  Restaurant: 'مطعم',
  Restaurants: 'المطاعم',
  'Restaurant Brand': 'علامة تجارية',
  'Restaurant Brands': 'العلامات التجارية',
  Bundle: 'باقة',
  Bundles: 'الباقات',
  'Bundle Requests': 'طلبات الباقات',
  'Bundle Status': 'حالة الباقة',
  'Delivery Fee': 'رسوم التوصيل',
  'Delivery Fees': 'رسوم التوصيل',
  Order: 'طلب',
  Orders: 'الطلبات',
  Trips: 'الرحلات',
  Wallet: 'محفظة',
  Wallets: 'المحافظ',
  'Wallet Transaction': 'معاملة محفظة',
  'Wallet Transactions': 'معاملات المحافظ',
  'Wallet Top-Up Requests': 'طلبات شحن المحافظ',
  'Top-Up Requests': 'طلبات شحن الرصيد',
  'Platform Settings': 'إعدادات المنصة',
  Contents: 'المحتوى',
  'App Downloads': 'تحميلات التطبيق',
  Dispatch: 'التوزيع',

  // ---------------------------------------------------------------- auth
  Login: 'تسجيل الدخول',
  'Sign up': 'إنشاء حساب',
  'Signing in…': 'جارٍ تسجيل الدخول…',
  'Email Address': 'البريد الإلكتروني',
  'Email Address*': 'البريد الإلكتروني*',
  'Enter email address': 'أدخل البريد الإلكتروني',
  'Enter password': 'أدخل كلمة المرور',
  Password: 'كلمة المرور',
  Documents: 'المستندات',
  'Verification documents. Check them before verifying the captain.': 'مستندات التحقق. راجعها قبل توثيق الكابتن.',
  'Not uploaded': 'لم يتم الرفع',
  'Captain updated': 'تم تحديث الكابتن',
  'Captain verified': 'تم توثيق الكابتن',
  'Captain unverified': 'تم إلغاء توثيق الكابتن',
  Unverify: 'إلغاء التوثيق',
  Enable: 'تفعيل',
  Disable: 'تعطيل',
  'is required': 'مطلوب',
  'Confirm Password': 'تأكيد كلمة المرور',
  'Passwords do not match': 'كلمتا المرور غير متطابقتين',
  'New Password': 'كلمة المرور الجديدة',
  'Email is required': 'البريد الإلكتروني مطلوب',
  'Password is required': 'كلمة المرور مطلوبة',
  'Login failed — check your credentials': 'فشل تسجيل الدخول — تحقق من بياناتك',
  'Password cannot start or end with spaces': 'لا يمكن أن تبدأ كلمة المرور أو تنتهي بمسافة',
  'Password must be less than 10 characters': 'يجب أن تكون كلمة المرور أقل من 10 أحرف',
  'First Name is required': 'الاسم الأول مطلوب',
  'Last Name is required': 'اسم العائلة مطلوب',
  'First Name*': 'الاسم الأول*',
  'Last Name*': 'اسم العائلة*',
  Company: 'الشركة',
  'Create Account': 'إنشاء حساب',
  'Already have an account?': 'لديك حساب بالفعل؟',
  'By Signing up, you agree to our': 'بإنشاء حساب، فإنك توافق على',
  'Terms of Service': 'شروط الخدمة',
  'Privacy Policy': 'سياسة الخصوصية',
  and: 'و',
  Poor: 'ضعيفة',
  Weak: 'ضعيفة',
  Normal: 'متوسطة',
  Good: 'جيدة',
  Strong: 'قوية',
  'Delivero Go Admin': 'لوحة إدارة ديليفرو جو',
  'Delivero Go': 'ديليفرو جو',
  '© All rights reserved': '© جميع الحقوق محفوظة',
  Terms: 'الشروط',
  'Terms and Conditions': 'الشروط والأحكام',

  // ---------------------------------------------------------------- dashboard
  'Active Captains': 'الكباتن النشطون',
  'Active Restaurants': 'المطاعم النشطة',
  'Orders Today': 'طلبات اليوم',
  'Orders On Hold': 'طلبات معلّقة',
  'Pending Sign-Ups': 'تسجيلات قيد المراجعة',
  'Pending Top-Ups': 'طلبات شحن قيد المراجعة',
  'Pending Bundle Requests': 'طلبات باقات قيد المراجعة',
  'Recent Orders': 'أحدث الطلبات',
  'Driver Responses': 'استجابات الكباتن',
  'ready or in_progress': 'جاهز أو في رحلة',
  '{delivered} delivered, {cancelled} cancelled': '{delivered} تم توصيلها، {cancelled} ملغاة',
  'no eligible captain found yet': 'لم يُعثر على كابتن مؤهل بعد',
  'none stuck right now': 'لا توجد طلبات عالقة الآن',
  'captains & restaurants': 'كباتن ومطاعم',
  'wallet top-up proof to review': 'إثباتات شحن رصيد للمراجعة',
  'Nothing pending review': 'لا شيء قيد المراجعة',
  'Nothing stuck right now': 'لا توجد طلبات عالقة الآن',
  'No orders yet': 'لا توجد طلبات بعد',
  'Wallet ledger is OUT OF BALANCE (net =': 'دفتر المحافظ غير متوازن (الصافي =',
  ') — investigate immediately.': ') — يجب التحقق فورًا.',
  'Ledger reconciliation: net =': 'مطابقة الدفتر: الصافي =',
  'OUT OF BALANCE, investigate immediately': 'غير متوازن، يجب التحقق فورًا',
  balanced: 'متوازن',

  // ---------------------------------------------------------------- location: districts / zones / matrix
  'Name (key)': 'الاسم (المفتاح)',
  'Seq #': 'التسلسل',
  'Sequence in zone': 'الترتيب داخل المنطقة',
  'Sequence #': 'رقم التسلسل',
  'Same-District Km': 'كم داخل الحي',
  'Same-District Min': 'دقائق داخل الحي',
  'Same-District Distance (km)': 'المسافة داخل الحي (كم)',
  'Same-District Duration (min)': 'المدة داخل الحي (دقيقة)',
  'Avg Km / Hop': 'متوسط كم / قفزة',
  'Avg Minutes / Hop': 'متوسط الدقائق / قفزة',
  'Km/Hop': 'كم/قفزة',
  'Min/Hop': 'دقيقة/قفزة',
  'Active (visible and deliverable)': 'نشط (ظاهر ومتاح للتوصيل)',
  'Current Zone': 'المنطقة الحالية',
  'Manage Districts': 'إدارة الأحياء',
  'Manage Districts —': 'إدارة الأحياء —',
  'Districts in this zone (': 'الأحياء في هذه المنطقة (',
  'Other districts': 'أحياء أخرى',
  'Assign here': 'تعيين هنا',
  'No districts assigned yet': 'لم يتم تعيين أحياء بعد',
  'No districts configured yet': 'لم يتم إعداد أحياء بعد',
  'Search by district, zone or city…': 'ابحث بالحي أو المنطقة أو المدينة…',
  '{configured} of {total} districts have a fee': '{configured} من {total} حي لها رسوم توصيل',
  'District outside the governorate': 'حي خارج المحافظة',
  'No fee': 'بدون رسوم',
  'Email (optional)': 'البريد الإلكتروني (اختياري)',
  'Attach an existing restaurant': 'إضافة مطعم موجود',
  'Only restaurants without a brand are listed.': 'تظهر فقط المطاعم غير التابعة لعلامة تجارية.',
  Attach: 'إضافة',
  'No branches yet — attach an existing restaurant above.': 'لا توجد فروع بعد — أضف مطعمًا موجودًا من الأعلى.',
  '{restaurant} added to {brand}': 'تمت إضافة {restaurant} إلى {brand}',
  'App login': 'الدخول للتطبيق',
  'Last login {time}': 'آخر دخول {time}',
  'Never logged in': 'لم يسجّل الدخول بعد',
  'Change login password': 'تغيير كلمة مرور الدخول',
  'Allow app login (set password)': 'السماح بالدخول للتطبيق (تعيين كلمة مرور)',
  'Disable app login': 'إيقاف الدخول للتطبيق',
  'App login for {phone}': 'الدخول للتطبيق للرقم {phone}',
  'This number can log in to the restaurant app with this password, with the same access as the main account. Saving logs it out of any device it is currently signed in on.':
    'يمكن لهذا الرقم الدخول لتطبيق المطعم بكلمة المرور هذه، بنفس صلاحيات الحساب الرئيسي. الحفظ يسجّل خروجه من أي جهاز مسجّل عليه حاليًا.',
  'Login password set for {phone}': 'تم تعيين كلمة مرور الدخول للرقم {phone}',
  'Login disabled for {phone}': 'تم إيقاف الدخول للرقم {phone}',
  'Loading districts…': 'جارٍ تحميل الأحياء…',
  'Edit Boundary': 'تعديل الحدود',
  'Edit Boundary —': 'تعديل الحدود —',
  'Save Boundary': 'حفظ الحدود',
  'Import GeoJSON': 'استيراد GeoJSON',
  'Could not read this file as a GeoJSON polygon': 'تعذّرت قراءة الملف كمضلع GeoJSON',
  'MultiPolygon boundaries are not supported — only a single Polygon per district.':
    'الحدود متعددة المضلعات غير مدعومة — مضلع واحد فقط لكل حي.',
  "Use the polygon tool (left toolbar) to draw the district's boundary, or the edit/delete tools to adjust or remove the existing one — or import one from a GeoJSON file.":
    'استخدم أداة المضلع (شريط الأدوات الجانبي) لرسم حدود الحي، أو أدوات التعديل/الحذف لضبط الحدود الحالية أو إزالتها — أو استورد الحدود من ملف GeoJSON.',
  'Search by Point': 'البحث بنقطة',
  "Enter a coordinate to find which district's drawn boundary contains it — narrows the table below to just that district.":
    'أدخل إحداثيات لمعرفة أي حي تقع داخل حدوده — يقتصر الجدول بالأسفل على هذا الحي فقط.',
  'No district boundary contains this point.': 'لا يوجد حي تحتوي حدوده على هذه النقطة.',
  'No drawn district boundary contains that point.': 'لا توجد حدود حي مرسومة تحتوي على هذه النقطة.',
  'Point falls inside {count} overlapping boundaries: {names}': 'النقطة تقع داخل {count} حدود متداخلة: {names}',
  'Point falls inside': 'النقطة تقع داخل',
  'overlapping boundaries:': 'حدود متداخلة:',
  '(district #': '(حي #',
  '(no boundary)': '(بدون حدود)',
  '— Select a governorate —': '— اختر محافظة —',
  'All cities': 'كل المدن',
  'Select a governorate above to view its district boundaries.': 'اختر محافظة بالأعلى لعرض حدود أحيائها.',
  'None of the {count} district(s) shown have a boundary drawn yet.': 'لم تُرسم حدود أي من الأحياء المعروضة ({count}) بعد.',
  'Show District Graph': 'عرض شبكة الأحياء',
  'Show District Graph (connections)': 'عرض شبكة الأحياء (الروابط)',
  'Loading connections…': 'جارٍ تحميل الروابط…',
  'No district_distance_matrix connections between the shown districts yet — add some from the District Matrix page.':
    'لا توجد روابط بين الأحياء المعروضة بعد — أضفها من صفحة مصفوفة المسافات.',
  "Pick a governorate to see every district boundary drawn in it so far, then narrow the map down by city and zone. Click anywhere on the map to check which district's boundary contains that point. Switch on":
    'اختر محافظة لعرض كل حدود الأحياء المرسومة فيها حتى الآن، ثم ضيّق الخريطة حسب المدينة والمنطقة. انقر في أي مكان على الخريطة لمعرفة الحي الذي تقع النقطة داخل حدوده. فعّل',
  "to show each district as a numbered circle and every district_distance_matrix connection between the shown districts — click a circle or a line for its details. These are the same connections the District Matrix page's table manages.":
    'لعرض كل حي كدائرة مرقّمة مع كل الروابط بين الأحياء المعروضة — انقر على دائرة أو خط لعرض تفاصيله. وهي نفس الروابط التي يديرها جدول صفحة مصفوفة المسافات.',
  'From District': 'من حي',
  'To District': 'إلى حي',
  'From district': 'من حي',
  'To district': 'إلى حي',
  'Via District': 'عبر حي',
  'Distance (km)': 'المسافة (كم)',
  'Duration (min)': 'المدة (دقيقة)',
  'Distance (km) — leave blank to calculate via ORS': 'المسافة (كم) — اتركها فارغة للحساب عبر ORS',
  'Duration (minutes) — leave blank to calculate via ORS': 'المدة (دقائق) — اتركها فارغة للحساب عبر ORS',
  'Also create the reverse connection (recommended)': 'إنشاء الرابط العكسي أيضًا (موصى به)',
  'Also create the reverse route (recommended)': 'إنشاء المسار العكسي أيضًا (موصى به)',
  'Insert district between': 'إدراج حي بينهما',
  'Insert District Between': 'إدراج حي بينهما',
  'Replaces the direct connection between': 'يستبدل الرابط المباشر بين',
  "with two new segments routed through the district you pick below — the direct connection (both directions, if both exist) is deleted, and each new segment's distance/duration is calculated automatically via ORS.":
    'بقطعتين جديدتين تمرّان عبر الحي الذي تختاره بالأسفل — يُحذف الرابط المباشر (في الاتجاهين إن وُجدا)، وتُحسب المسافة/المدة لكل قطعة جديدة تلقائيًا عبر ORS.',
  'No other districts available to route through': 'لا توجد أحياء أخرى متاحة للمرور عبرها',
  'District inserted — the direct connection was replaced with the new route.': 'تم إدراج الحي — واستُبدل الرابط المباشر بالمسار الجديد.',
  'Travel-Time & Route Resolver (diagnostic)': 'أداة حساب زمن الرحلة والمسار (تشخيصية)',
  'Shows exactly which source (zone-sequence formula, matrix override, or a flagged estimate) would be used for a district pair, and — separately — the actual route (the chain of districts, hop by hop) and total time the district graph would take between them. Useful for finding coverage gaps, and for confirming the matrix is connected enough for multi-hop stacking to actually work.':
    'يوضح المصدر الذي سيُستخدم لكل زوج من الأحياء (معادلة تسلسل المنطقة، أو قيمة من المصفوفة، أو تقدير مُعلَّم)، وكذلك المسار الفعلي (سلسلة الأحياء قفزة بقفزة) وإجمالي الزمن عبر شبكة الأحياء. مفيد لاكتشاف الفجوات والتأكد من أن المصفوفة مترابطة بما يكفي لتجميع الطلبات عبر عدة قفزات.',
  ' — no real data for this pair yet, this is a fallback guess': ' — لا توجد بيانات حقيقية لهذا الزوج بعد، هذا تقدير احتياطي',
  'No route connects these two districts in the graph yet — add matrix rows to link them, directly or via an intermediate district.':
    'لا يوجد مسار يربط هذين الحيين في الشبكة بعد — أضف صفوفًا في المصفوفة لربطهما مباشرة أو عبر حي وسيط.',
  'Graph route —': 'مسار الشبكة —',
  "A new district has no matrix coverage until added here — rows are no longer auto-generated. Pick the From/To districts for every meaningful connection below and leave Distance/Duration blank to calculate them automatically from OpenRouteService's real driving route between them, marked":
    'الحي الجديد لا يظهر في المصفوفة حتى يُضاف هنا — لم تعد الصفوف تُنشأ تلقائيًا. اختر الحي المصدر والوجهة لكل رابط مهم بالأسفل واترك المسافة/المدة فارغتين لحسابهما تلقائيًا من مسار القيادة الحقيقي عبر OpenRouteService، وتُعلَّم بـ',
  '— or fill them in yourself to override ORS with a known value. A pair with no row falls back to the zone-sequence formula or a flagged 30-minute':
    '— أو أدخلهما بنفسك لتجاوز ORS بقيمة معروفة. الزوج الذي ليس له صف يعتمد على معادلة تسلسل المنطقة أو على 30 دقيقة',
  'default. Check "also create the reverse connection" to add both directions at once — if you typed in Distance/Duration yourself, the same values are used for both directions; leave them blank and each direction is calculated via ORS independently, since real travel time can differ by direction. To route an existing connection through an intermediate district instead of a direct edge, use that row\'s':
    'افتراضيًا. فعّل "إنشاء الرابط العكسي أيضًا" لإضافة الاتجاهين معًا — إذا أدخلت المسافة/المدة بنفسك تُستخدم نفس القيم للاتجاهين، وإذا تركتها فارغة يُحسب كل اتجاه عبر ORS على حدة لأن زمن الرحلة قد يختلف حسب الاتجاه. لتمرير رابط قائم عبر حي وسيط بدلًا من الرابط المباشر، استخدم إجراء',
  'action — it replaces the direct connection for you rather than requiring you to delete and re-add it by hand. To see these connections drawn on a real map instead of this table, switch on':
    'في ذلك الصف — يستبدل الرابط المباشر تلقائيًا بدلًا من حذفه وإعادة إضافته يدويًا. لعرض هذه الروابط على خريطة حقيقية بدلًا من هذا الجدول، فعّل',
  'on the District Polygons page.': 'في صفحة حدود الأحياء.',
  'Distance & direction finder': 'حساب المسافة والاتجاه',
  'Pick both a captain and a restaurant to calculate distance and direction.': 'اختر كابتن ومطعمًا لحساب المسافة والاتجاه.',
  'Straight-line:': 'خط مستقيم:',
  'Real road route:': 'المسار الفعلي على الطريق:',
  'Real road route unavailable — showing straight-line estimate only': 'المسار الفعلي غير متاح — يُعرض تقدير الخط المستقيم فقط',

  // ---------------------------------------------------------------- delivery restrictions
  'Restrict a District': 'تقييد حي',
  Restriction: 'قيد',
  'Restriction not found': 'القيد غير موجود',
  'Lift Restriction': 'رفع القيد',
  'Lift the restriction on': 'رفع القيد عن',
  Lifted: 'تم الرفع',
  'Lifted (history)': 'القيود المرفوعة (السجل)',
  'No district is restricted right now': 'لا يوجد حي مقيّد حاليًا',
  'No lifted restrictions yet': 'لا توجد قيود مرفوعة بعد',
  'merged automatically': 'دُمج تلقائيًا',
  'Destination district': 'حي الوجهة',
  'Destination District': 'حي الوجهة',
  Entries: 'العناصر',
  "Entries — who can't deliver there, and why": 'العناصر — من لا يمكنه التوصيل هناك، ولماذا',
  'No entries yet — choose a type, a target and a reason, then Add': 'لا توجد عناصر بعد — اختر النوع والهدف والسبب ثم اضغط إضافة',
  'Entry added — its restaurants were notified': 'تمت إضافة العنصر — وتم إشعار مطاعمه',
  'Entry removed — its restaurants were notified': 'تمت إزالة العنصر — وتم إشعار مطاعمه',
  'Restriction lifted — targeted restaurants were notified': 'تم رفع القيد — وتم إشعار المطاعم المعنية',
  "The last entry can't be removed — lift the restriction instead": 'لا يمكن إزالة العنصر الأخير — ارفع القيد بدلًا من ذلك',
  "restaurant(s) currently can't deliver to": 'مطعم/مطاعم لا يمكنها التوصيل حاليًا إلى',
  "Deliveries TO this district are blocked for the entries below. Districts already restricted aren't listed — open their row instead.":
    'التوصيل إلى هذا الحي محظور على العناصر بالأسفل. الأحياء المقيّدة بالفعل لا تظهر هنا — افتح صفها بدلًا من ذلك.',
  "Every targeted restaurant will be able to deliver to this district again and will be notified that it's available.":
    'ستتمكن كل المطاعم المعنية من التوصيل إلى هذا الحي مجددًا وسيتم إشعارها بذلك.',
  'Restaurants in district': 'مطاعم في حي',
  'Restaurants in zone': 'مطاعم في منطقة',
  'Restaurants located in district': 'المطاعم الموجودة في حي',
  'Restaurants located in zone': 'المطاعم الموجودة في منطقة',
  'Create & Notify': 'إنشاء وإشعار',

  // ---------------------------------------------------------------- identity / users / registration
  'Name (key, e.g. operations)': 'الاسم (المفتاح، مثال: operations)',
  'Reset Password': 'إعادة تعيين كلمة المرور',
  'Set a new password for': 'تعيين كلمة مرور جديدة لـ',
  'Password (optional — leave blank to set later via Reset Password)':
    'كلمة المرور (اختياري — اتركها فارغة لتعيينها لاحقًا من إعادة تعيين كلمة المرور)',
  'Captains and restaurants request an account from their app, but nothing is created until you verify a request here — verifying creates the account (with a random password — use Reset Password afterward); rejecting creates nothing.':
    'يطلب الكباتن والمطاعم حسابًا من التطبيق، ولا يُنشأ أي حساب حتى توثّق الطلب هنا — التوثيق ينشئ الحساب (بكلمة مرور عشوائية — استخدم إعادة تعيين كلمة المرور بعدها)؛ والرفض لا ينشئ شيئًا.',
  'No pending registration requests': 'لا توجد طلبات تسجيل قيد المراجعة',
  'Verify Registration Request': 'توثيق طلب التسجيل',
  'Reject Registration Request': 'رفض طلب التسجيل',
  'Create a {type} account for {name}?': 'إنشاء حساب {type} لـ {name}؟',
  'A random password is generated — use Reset Password on the new {type} afterward so they can log in.':
    'سيتم إنشاء كلمة مرور عشوائية — استخدم إعادة تعيين كلمة المرور للحساب الجديد ({type}) بعدها حتى يتمكن من تسجيل الدخول.',
  'Rejection reason': 'سبب الرفض',
  'National ID': 'الرقم القومي',
  'National ID:': 'الرقم القومي:',
  '· Vehicle:': '· المركبة:',
  'District:': 'الحي:',
  '· Address:': '· العنوان:',
  '· Brand:': '· العلامة التجارية:',
  'ID Front': 'البطاقة (أمام)',
  'ID Back': 'البطاقة (خلف)',
  'ID Front Photo': 'صورة البطاقة (أمام)',
  'ID Back Photo': 'صورة البطاقة (خلف)',
  License: 'الرخصة',
  'Driver License': 'رخصة القيادة',
  'Driver License Photo': 'صورة رخصة القيادة',
  'Profile Photo': 'الصورة الشخصية',
  Vehicle: 'المركبة',
  'Vehicle Photo': 'صورة المركبة',
  'Vehicle Plate': 'لوحة المركبة',
  'Vehicle Type': 'نوع المركبة',
  Motorcycle: 'موتوسيكل',
  Bicycle: 'دراجة',
  Car: 'سيارة',

  // ---------------------------------------------------------------- captains
  'New Captain': 'كابتن جديد',
  'Captain ID': 'معرّف الكابتن',
  'Captain disabled': 'تم تعطيل الكابتن',
  'Captain re-enabled (set to not_ready)': 'تم تفعيل الكابتن مجددًا (الحالة: غير جاهز)',
  'Disable / Enable': 'تعطيل / تفعيل',
  'Activate / Deactivate': 'تفعيل / إلغاء التفعيل',
  'Verify / Unverify': 'توثيق / إلغاء التوثيق',
  'Working Zone': 'منطقة العمل',
  "Working Zone (blank = district's zone)": 'منطقة العمل (فارغة = منطقة الحي)',
  'Captains (motorcycle, colored by status — click one for its trip) and active restaurants (purple fork and knife) on one map.':
    'الكباتن (دراجة نارية ملوّنة حسب الحالة — انقر على أي كابتن لعرض رحلته) والمطاعم النشطة (شوكة وسكين باللون البنفسجي) على خريطة واحدة.',
  'Trip #{id}': 'رحلة #{id}',
  'No active trip': 'لا توجد رحلة نشطة',
  '{count} order(s)': '{count} طلب',
  'Loading trip…': 'جارٍ تحميل الرحلة…',
  'Auto-refresh (10s)': 'تحديث تلقائي (10 ث)',
  Ready: 'جاهز',
  'In progress': 'في رحلة',
  Requesting: 'يطلب',
  Busy: 'مشغول',
  '{count} captains on the map': '{count} كابتن على الخريطة',
  'Captain (color = status — click for name, trip and orders)': 'كابتن (اللون = الحالة — انقر لعرض الاسم والرحلة والطلبات)',
  'Active restaurant (click for details)': 'مطعم نشط (انقر لعرض التفاصيل)',
  'No captains (ready/in_progress/requesting/busy) or active restaurants currently have a known location.':
    'لا يوجد كباتن (جاهز/في رحلة/يطلب/مشغول) أو مطاعم نشطة بموقع معروف حاليًا.',
  'Last ping:': 'آخر إشارة:',
  'Go to location': 'اذهب للموقع',
  'Last location': 'آخر موقع',
  'Last location time': 'وقت آخر موقع',
  'Restaurant phone': 'موبايل المطعم',
  Trip: 'الرحلة',
  'Google Maps is on in Platform Settings, but this build has no Google Maps key — showing OpenStreetMap.': 'خرائط جوجل مفعّلة في إعدادات المنصة، لكن هذه النسخة بلا مفتاح خرائط جوجل — تُعرض خريطة OpenStreetMap.',
  'Use Google Maps on Live Tracking': 'استخدام خرائط جوجل في التتبع المباشر',
  'On: the Live Tracking map is Google Maps. Off: it is OpenStreetMap (free, no key). Google Maps needs a billing-enabled key built into the portal; without one, OpenStreetMap is shown either way.':
    'عند التفعيل: خريطة التتبع المباشر هي خرائط جوجل. عند الإيقاف: تُعرض خريطة OpenStreetMap (مجانية وبلا مفتاح). تحتاج خرائط جوجل إلى مفتاح مفعّل به الفوترة ومضمّن في البوابة؛ وبدونه تُعرض OpenStreetMap في الحالتين.',
  'Offer out': 'عرض مُرسل',
  'Trip started': 'وقت بدء الرحلة',
  'Expected at restaurant': 'وقت وصول المطعم المتوقع',
  'Arrived at restaurant': 'وقت وصول المطعم الفعلي',
  None: 'لا يوجد',
  Map: 'خريطة',
  Satellite: 'قمر صناعي',

  // ---------------------------------------------------------------- restaurants
  'Restaurant ID': 'معرّف المطعم',
  'Edit Restaurant —': 'تعديل المطعم —',
  'Avg Preparation Time (min)': 'متوسط وقت التحضير (دقيقة)',
  'Opens At (HH:MM)': 'يفتح في (HH:MM)',
  'Closes At (HH:MM)': 'يغلق في (HH:MM)',
  'Request Fee Percent (%)': 'نسبة عمولة الطلب (%)',
  'Daily At-Restaurant Cancellation Limit (blank = platform default)': 'الحد اليومي للإلغاء في المطعم (فارغ = الافتراضي للمنصة)',
  'Settings saved': 'تم حفظ الإعدادات',
  'Assign Districts': 'تعيين الأحياء',
  "Districts this restaurant delivers to, and the delivery fee charged for each. A district with no fee row here can't be selected as an order destination.":
    'الأحياء التي يوصّل إليها هذا المطعم، ورسوم التوصيل لكل منها. الحي الذي ليس له رسوم هنا لا يمكن اختياره كوجهة للطلب.',
  'Delivery fee added': 'تمت إضافة رسوم التوصيل',
  'Delivery fee removed': 'تمت إزالة رسوم التوصيل',
  'Delivery fee (EGP)': 'رسوم التوصيل (ج.م)',
  'No fee configured': 'لا توجد رسوم محددة',
  Fee: 'الرسوم',
  'Fee (EGP)': 'الرسوم (ج.م)',
  'Download Excel': 'تحميل Excel',
  'Upload Excel': 'رفع Excel',
  "Couldn't read that file — upload an .xlsx, .xls or .csv sheet": 'تعذّرت قراءة الملف — ارفع ملف ‎.xlsx أو ‎.xls أو ‎.csv',
  'The file has no sheets': 'الملف لا يحتوي على أوراق',
  'Fix these rows and upload again — nothing has been saved:': 'صحّح هذه الصفوف وارفع الملف مرة أخرى — لم يتم حفظ أي شيء:',
  '…and': '…و',
  more: 'أخرى',
  'No fees found in this file.': 'لا توجد رسوم في هذا الملف.',
  '{count} fee(s) will be added or updated.': 'ستتم إضافة أو تحديث {count} من الرسوم.',
  '{count} row(s) with an empty fee will be left unchanged.': '{count} صف/صفوف برسوم فارغة ستبقى دون تغيير.',
  'Row {row}': 'الصف {row}',
  'District ID {id} not found': 'معرّف الحي {id} غير موجود',
  'District "{name}" not found': 'الحي "{name}" غير موجود',
  'District name "{name}" is ambiguous — fill in its District ID': 'اسم الحي "{name}" غير واضح — أدخل معرّف الحي',
  'District "{name}" is inactive': 'الحي "{name}" غير نشط',
  'Fee "{fee}" for "{name}" isn\'t a valid amount': 'الرسوم "{fee}" للحي "{name}" ليست مبلغًا صالحًا',
  '"{name}" also appears on row {row}': '"{name}" موجود أيضًا في الصف {row}',
  'Assign Bundle': 'تعيين باقة',
  'Request Bundle': 'طلب باقة',
  'Bundle requested': 'تم طلب الباقة',
  'Bundle approved': 'تمت الموافقة على الباقة',
  'Bundle request rejected': 'تم رفض طلب الباقة',
  'No bundle requested yet': 'لم يتم طلب باقة بعد',
  'A request is already pending below — approve or reject it before requesting another.':
    'يوجد طلب قيد الانتظار بالأسفل — اقبله أو ارفضه قبل طلب باقة أخرى.',
  '/mo, up to': '/شهريًا، حتى',
  'Bundle Expires': 'انتهاء الباقة',
  'Expires At (optional — defaults to +30 days)': 'تاريخ الانتهاء (اختياري — الافتراضي بعد 30 يومًا)',
  'No Bundle': 'بدون باقة',
  'Cancel Request': 'إلغاء الطلب',
  'Add number': 'إضافة رقم',
  'Phone number added': 'تمت إضافة الرقم',
  'Phone number removed': 'تمت إزالة الرقم',
  'No additional numbers yet': 'لا توجد أرقام إضافية بعد',
  'e.g. Manager': 'مثال: المدير',
  "Additional numbers this restaurant can be reached on, alongside its required phone. Each is independent — remove one (e.g. a staff member's own number) the moment it stops working without affecting the others.":
    'أرقام إضافية للتواصل مع المطعم بجانب رقمه الأساسي. كل رقم مستقل — احذف أي رقم (مثل رقم أحد الموظفين) بمجرد توقفه دون التأثير على الباقي.',
  'Captain Blacklist': 'قائمة حظر الكباتن',
  'Captain Blacklist —': 'قائمة حظر الكباتن —',
  'Block a captain': 'حظر كابتن',
  'Currently blocked (': 'المحظورون حاليًا (',
  'No captains blocked for this restaurant': 'لا يوجد كباتن محظورون لهذا المطعم',
  'View Branches': 'عرض الفروع',
  'Branches —': 'الفروع —',
  "No branches linked yet — assign one from the Restaurants page's edit dialog.":
    'لا توجد فروع مرتبطة بعد — اربط فرعًا من نافذة تعديل المطعم في صفحة المطاعم.',
  'Max Captains': 'الحد الأقصى للكباتن',
  'Max Orders/Day': 'الحد الأقصى للطلبات/يوم',
  'Max Orders / Day (blank = unlimited)': 'الحد الأقصى للطلبات / يوم (فارغ = غير محدود)',
  'Price/Month': 'السعر/شهر',
  'Price / Month (EGP)': 'السعر / شهر (ج.م)',
  'Name (e.g. gold)': 'الاسم (مثال: gold)',
  'Restaurants request a bundle from their app; approving here activates their subscription immediately and lets them start placing orders once bundle captains are assigned.':
    'تطلب المطاعم الباقة من التطبيق؛ القبول هنا يفعّل الاشتراك فورًا ويسمح لها ببدء الطلبات بمجرد تعيين كباتن الباقة.',
  'No pending bundle requests': 'لا توجد طلبات باقات قيد المراجعة',
  'Approve Bundle Request': 'قبول طلب الباقة',
  'Reject Bundle Request': 'رفض طلب الباقة',
  'Live capacity for restaurants with an active bundle subscription: drivers assigned vs. the bundle\'s driver cap, and bundle-dispatched orders placed today vs. the bundle\'s daily cap (blank/"Unlimited" bundles have no daily cap).':
    'السعة الحالية للمطاعم ذات الاشتراك النشط: الكباتن المعيّنون مقابل الحد الأقصى للباقة، وطلبات الباقة اليوم مقابل الحد اليومي (الباقات "غير المحدودة" ليس لها حد يومي).',
  'No restaurants have an active bundle': 'لا توجد مطاعم لديها باقة نشطة',
  'Remaining Drivers': 'الكباتن المتبقون',
  'Requests Today': 'طلبات اليوم',
  'Remaining Requests Today': 'الطلبات المتبقية اليوم',

  // ---------------------------------------------------------------- orders & trips
  'New Order': 'طلب جديد',
  'Create Order': 'إنشاء طلب',
  'Order ID': 'رقم الطلب',
  'Order #': 'طلب #',
  'Order Info': 'بيانات الطلب',
  'Order not found': 'الطلب غير موجود',
  'No orders found': 'لا توجد طلبات',
  'Clear search — showing recent orders': 'مسح البحث — عرض أحدث الطلبات',
  'Search by name or id…': 'ابحث بالاسم أو الرقم…',
  Customer: 'العميل',
  'Customer phone': 'هاتف العميل',
  'Delivery address': 'عنوان التوصيل',
  'Delivery district': 'حي التوصيل',
  'Delivery fee': 'رسوم التوصيل',
  'COD amount': 'مبلغ الدفع عند الاستلام',
  'Payment status': 'حالة الدفع',
  'Mark as': 'تحديد كـ',
  'Not yet assigned': 'لم يتم التعيين بعد',
  Assigned: 'تاريخ التعيين',
  Accepted: 'تاريخ القبول',
  'At restaurant': 'الوصول للمطعم',
  'Picked up': 'تاريخ الاستلام',
  Delivered: 'تاريخ التوصيل',
  Cancelled: 'تاريخ الإلغاء',
  'Cancelled by': 'ألغاه',
  'Pickup estimate': 'تقدير الاستلام',
  'arriving ~{time}': 'الوصول ~{time}',
  'ETA unavailable': 'وقت الوصول غير متاح',
  'Status Timeline': 'تسلسل الحالات',
  'Changed By': 'بواسطة',
  'Every captain this order was offered to, and how they responded.': 'كل كابتن عُرض عليه هذا الطلب، وكيف استجاب.',
  'No dispatch attempts recorded yet': 'لا توجد محاولات توزيع مسجلة بعد',
  'Cancel Order': 'إلغاء الطلب',
  'Cancel Order #': 'إلغاء الطلب #',
  Reassign: 'إعادة تعيين',
  'Reassign Order #': 'إعادة تعيين الطلب #',
  'Reassigning…': 'جارٍ إعادة التعيين…',
  'Previous Captain': 'الكابتن السابق',
  'Who had this order before it was reassigned — for handoff/support purposes.':
    'الكابتن الذي كان لديه الطلب قبل إعادة تعيينه — لأغراض التسليم/الدعم.',
  'as of {time}': 'حتى {time}',
  Unavailable: 'غير متاح',
  "Ranked by distance from the original captain's last known position": 'مرتبون حسب المسافة من آخر موقع معروف للكابتن الأصلي',
  'This order was cancelled before pickup (': 'تم إلغاء هذا الطلب قبل الاستلام (',
  '). It will be returned to the dispatch pool and offered to the next eligible captain automatically — no captain to pick here.':
    '). سيعود إلى مجمع التوزيع ويُعرض تلقائيًا على الكابتن المؤهل التالي — لا حاجة لاختيار كابتن هنا.',
  'Return to Dispatch': 'إعادة إلى التوزيع',
  'Removed from order': 'أُزيل من الطلب',
  'No available captain in this restaurant’s city': 'لا يوجد كابتن متاح في مدينة هذا المطعم',
  "Who covers the captain's compensation for this cancellation?": 'من يتحمل تعويض الكابتن عن هذا الإلغاء؟',
  'Charge the restaurant': 'تحميل المطعم',
  'Cover from the platform wallet': 'من محفظة المنصة',
  'No compensation': 'بدون تعويض',
  'Standard compensation': 'التعويض القياسي',
  'Captain compensation': 'تعويض الكابتن',
  'Compensation amount (optional)': 'مبلغ التعويض (اختياري)',
  'Max compensation allowed': 'أقصى تعويض مسموح',
  'Paid from whichever side is selected above, automatically capped at {amount} EGP — leave blank for none.':
    'يُدفع من الجهة المحددة بالأعلى، بحد أقصى تلقائي {amount} ج.م — اتركه فارغًا لعدم الدفع.',
  "Reference — this order's own figures": 'للمرجع — أرقام هذا الطلب',
  'Request fee (platform commission)': 'عمولة الطلب (عمولة المنصة)',
  'Pick a restaurant first': 'اختر مطعمًا أولًا',
  'Prep time (minutes)': 'وقت التحضير (دقائق)',
  "Leave blank to use the restaurant's average": 'اتركه فارغًا لاستخدام متوسط المطعم',
  'Prefilled from the fee table': 'مُعبأ من جدول الرسوم',
  'Restricted:': 'مقيّد:',
  'Auto-assign': 'تعيين تلقائي',
  'Specific captain': 'كابتن محدد',
  'Offered to the nearest eligible captains one at a time, the same as any other order.':
    'يُعرض على أقرب الكباتن المؤهلين واحدًا تلو الآخر، مثل أي طلب آخر.',
  "Ready and in-progress captains, nearest to the restaurant first. If they don't respond in time, the order is auto-assigned.":
    'الكباتن الجاهزون وفي رحلة، الأقرب للمطعم أولًا. إذا لم يستجب الكابتن في الوقت المحدد يُعيَّن الطلب تلقائيًا.',
  "On trip #{trip} — this order is offered as an extra stop on it (it passed the same stacking checks as automatic dispatch). If they don't respond in time, the order is auto-assigned.":
    'في الرحلة #{trip} — يُعرض هذا الطلب كمحطة إضافية عليها (اجتاز نفس فحوص التجميع في التوزيع التلقائي). إذا لم يستجب الكابتن في الوقت المحدد يُعيَّن الطلب تلقائيًا.',
  'No ready, affording captain is currently available nearby. Try again once a captain comes online.':
    'لا يوجد كابتن جاهز ولديه رصيد كافٍ بالقرب حاليًا. حاول مرة أخرى عندما يتصل كابتن.',
  'distance unknown': 'المسافة غير معروفة',
  'on a trip ({active}/{max} orders)': 'في رحلة ({active}/{max} طلبات)',
  'pick a district to check this trip': 'اختر حيًا للتحقق من هذه الرحلة',
  "can't stack": 'لا يمكن التجميع',
  'insufficient wallet balance': 'رصيد المحفظة غير كافٍ',
  'Trip #': 'رحلة #',
  'Trip ID': 'رقم الرحلة',
  'Trip Info': 'بيانات الرحلة',
  'Trip not found': 'الرحلة غير موجودة',
  'No trips found': 'لا توجد رحلات',
  'Clear search — showing all trips': 'مسح البحث — عرض كل الرحلات',
  'Time budget': 'الوقت المتاح',
  'Budget (min)': 'الوقت المتاح (دقيقة)',
  'Budget expires': 'انتهاء الوقت المتاح',
  'From restaurant': 'من مطعم',
  'Wait duration': 'مدة الانتظار',
  'Wait Duration (min)': 'مدة الانتظار (دقيقة)',
  'Waiting until': 'الانتظار حتى',
  'Waiting Until': 'الانتظار حتى',
  'End Wait': 'إنهاء الانتظار',
  'Wait ended — captain is now Busy': 'انتهى الانتظار — الكابتن الآن مشغول',
  'Nothing to end': 'لا يوجد ما يُنهى',
  'Orders on this trip': 'طلبات هذه الرحلة',
  'No orders on this trip': 'لا توجد طلبات في هذه الرحلة',
  'Held Since': 'معلّق منذ',
  'Prep (min)': 'التحضير (دقيقة)',

  // ---------------------------------------------------------------- finance
  'Platform Treasury': 'خزينة المنصة',
  'Platform Wallet': 'محفظة المنصة',
  'Captain Wallets': 'محافظ الكباتن',
  'Restaurant Wallets': 'محافظ المطاعم',
  'Captain / Restaurant': 'كابتن / مطعم',
  'Search by phone number...': 'ابحث برقم الهاتف...',
  'No wallets found': 'لا توجد محافظ',
  'No wallets match that phone number': 'لا توجد محافظ بهذا الرقم',
  'Search by name or phone...': 'ابحث بالاسم أو رقم الهاتف...',
  'No wallets match your search': 'لا توجد محافظ مطابقة للبحث',
  'Wallet not found': 'المحفظة غير موجودة',
  'Wallet #': 'محفظة #',
  'Top up': 'شحن الرصيد',
  'Top Up': 'شحن الرصيد',
  'Top Up —': 'شحن الرصيد —',
  'Manual adjustment': 'تسوية يدوية',
  'Manual Adjustment —': 'تسوية يدوية —',
  'Apply Adjustment': 'تطبيق التسوية',
  'Every adjustment is double-entry — pick the wallet on the other side': 'كل تسوية بقيد مزدوج — اختر المحفظة في الطرف الآخر',
  'Counterpart Wallet ID': 'معرّف المحفظة المقابلة',
  'Credit this wallet (debit counterpart)': 'إضافة لهذه المحفظة (خصم من المقابلة)',
  'Debit this wallet (credit counterpart)': 'خصم من هذه المحفظة (إضافة للمقابلة)',
  'View transactions': 'عرض المعاملات',
  Transactions: 'المعاملات',
  'Transaction History': 'سجل المعاملات',
  'No transactions yet': 'لا توجد معاملات بعد',
  Credit: 'إضافة',
  "Credit {amount} EGP to {name}'s wallet?": 'إضافة {amount} ج.م إلى محفظة {name}؟',
  'The {type} will be notified immediately.': 'سيتم إشعار ({type}) فورًا.',
  'Captains and restaurants can request a wallet top-up from their app. Approving credits their wallet immediately and sends them a notification; cancelling sends one too, with your reason if given.':
    'يمكن للكباتن والمطاعم طلب شحن المحفظة من التطبيق. القبول يضيف الرصيد فورًا ويرسل إشعارًا؛ والإلغاء يرسل إشعارًا أيضًا مع السبب إن وُجد.',
  'No pending top-up requests': 'لا توجد طلبات شحن قيد المراجعة',
  'Approve Top-Up Request': 'قبول طلب الشحن',
  'Cancel Top-Up Request': 'إلغاء طلب الشحن',
  'Receipt image (optional)': 'صورة الإيصال (اختياري)',

  // ---------------------------------------------------------------- platform settings
  'Save Settings': 'حفظ الإعدادات',
  'Platform settings updated': 'تم تحديث إعدادات المنصة',
  'Order Offer Duration': 'مدة عرض الطلب',
  'Stacking Offer Duration': 'مدة عرض الطلب الإضافي',
  'Hold Retry Interval': 'فترة إعادة محاولة الطلبات المعلقة',
  'How often orders on hold (no eligible captain found) are tried again. A shorter interval reaches a newly free captain sooner.':
    'عدد مرات إعادة محاولة الطلبات المعلقة (التي لم يُعثر لها على كابتن مؤهل). الفترة الأقصر تصل إلى الكابتن المتاح حديثًا بشكل أسرع.',
  'How long a captain has to respond to a normal ("ready") offer before it times out and cascades to the next candidate.':
    'المدة المتاحة للكابتن للرد على العرض العادي ("جاهز") قبل انتهاء المهلة وانتقاله للمرشح التالي.',
  'How long a captain already mid-trip has to respond to a stacking offer (an additional order added to their current trip) before it times out and cascades to the next candidate — set independently from the normal offer duration above.':
    'المدة المتاحة لكابتن في رحلة للرد على عرض طلب إضافي (يُضاف إلى رحلته الحالية) قبل انتهاء المهلة وانتقاله للمرشح التالي — تُضبط بشكل مستقل عن مدة العرض العادي بالأعلى.',
  'Max Orders Per Captain': 'الحد الأقصى للطلبات لكل كابتن',
  'How many orders a single captain may carry on one trip at once — the stacking cap both dispatch engines use when deciding whether a captain already mid-trip can be offered a second order.':
    'عدد الطلبات التي يمكن لكابتن واحد حملها في رحلة واحدة — وهو حد التجميع الذي يستخدمه محركا التوزيع لتحديد إمكانية عرض طلب ثانٍ على كابتن في رحلة.',
  'Max Captain Search Radius': 'أقصى نطاق للبحث عن كابتن',
  "How far (straight-line km) a captain may be from the restaurant to be considered a dispatch candidate at all — applies to both ready and in-progress (stacking) candidates, for dedicated and shared restaurants alike. Distinct from a restaurant's own Max Delivery Radius (which caps how far the customer's destination can be).":
    'أقصى بُعد (كم بخط مستقيم) بين الكابتن والمطعم ليُعتبر مرشحًا للتوزيع — ينطبق على الكباتن الجاهزين وفي رحلة (التجميع)، للمطاعم المخصصة والمشتركة. يختلف عن نطاق التوصيل الأقصى للمطعم (الذي يحدد بُعد وجهة العميل).',
  'Max Unanswered Offers Per Captain': 'الحد الأقصى للعروض دون رد لكل كابتن',
  "How many times the same order can be offered to the same captain without a response before they're permanently skipped for that order (an explicit reject has always been permanent — this caps repeated timeouts the same way, so one unreachable captain can't absorb every dispatch round forever).":
    'عدد مرات عرض نفس الطلب على نفس الكابتن دون رد قبل تخطيه نهائيًا لهذا الطلب (الرفض الصريح نهائي دائمًا — وهذا يحدّ من تكرار انتهاء المهلة بنفس الطريقة، حتى لا يستهلك كابتن غير متاح كل جولات التوزيع).',
  'Captain Busy Grace Period': 'مهلة ما قبل الانشغال',
  "How long a captain who's just picked up everything they're holding stays eligible for one more stacked order before flipping to Busy — capped automatically by however much slack their own trip deadline still has, so waiting never pushes an already-promised delivery later. Set to 0 to go back to flipping to Busy immediately.":
    'المدة التي يبقى فيها الكابتن بعد استلام كل طلباته مؤهلًا لطلب إضافي قبل أن يصبح مشغولًا — محدودة تلقائيًا بالوقت المتبقي في رحلته، حتى لا يؤخر الانتظار أي توصيل موعود. اضبطها على 0 ليصبح مشغولًا فورًا.',
  'Max Unpaid COD Orders Per Captain': 'الحد الأقصى لطلبات الدفع عند الاستلام غير المسددة لكل كابتن',
  "Once a captain has this many cash-on-delivery orders picked up and still not confirmed as paid over to the restaurant, they stop receiving new offers platform-wide until at least one is confirmed paid. A restaurant confirms payment from the order's own detail screen after being prompted on pickup.":
    'عندما يصل الكابتن لهذا العدد من طلبات الدفع عند الاستلام التي استلمها ولم يُؤكد تسليم مبلغها للمطعم، يتوقف عن تلقي عروض جديدة حتى يُؤكد دفع واحد منها على الأقل. يؤكد المطعم الدفع من شاشة تفاصيل الطلب بعد تنبيهه عند الاستلام.',
  'Restrict Dispatch By Zone': 'تقييد التوزيع حسب المنطقة',
  "When on, a captain is only offered orders from restaurants in the same zone as the captain's own working district (set on each captain's edit page) — a captain or restaurant with no district assigned yet is unaffected by this toggle either way. Off by default; turning this on before districts are assigned would silently empty the candidate pool.":
    'عند التفعيل، تُعرض على الكابتن طلبات المطاعم الموجودة في نفس منطقة حي عمله فقط (يُضبط في صفحة تعديل الكابتن) — الكابتن أو المطعم بدون حي معيّن لا يتأثر. معطّل افتراضيًا؛ تفعيله قبل تعيين الأحياء سيُفرغ قائمة المرشحين دون تنبيه.',
  'Real-Time Dispatch Channel': 'قناة التوزيع اللحظي',
  "How a captain's live blind offer is mirrored for real-time listening, alongside (not instead of) the push notification.":
    'طريقة نقل العرض المباشر للكابتن للاستماع اللحظي، بجانب الإشعار (وليس بدلًا منه).',
  WebSocket: 'WebSocket',
  'WebSocket (Socket.IO)': 'WebSocket (Socket.IO)',
  Firestore: 'Firestore',
  "pushes the offer over this API's own Socket.IO connection — no external service needed.":
    'يرسل العرض عبر اتصال Socket.IO الخاص بالخادم — دون خدمة خارجية.',
  'mirrors it into the driver_dispatches Firestore collection instead, for older captain-app builds that only know how to listen there.':
    'ينسخه إلى مجموعة driver_dispatches في Firestore، لإصدارات تطبيق الكابتن القديمة التي تستمع هناك فقط.',
  'Stacking & Routing': 'التجميع والمسارات',
  'Stacking Route Engine': 'محرك مسارات التجميع',
  'Which algorithm decides whether a captain already mid-trip can be offered a second (stacked) order:':
    'الخوارزمية التي تحدد إمكانية عرض طلب ثانٍ (مُجمّع) على كابتن في رحلة:',
  ORS: 'ORS',
  'ORS (OpenRouteService)': 'ORS (OpenRouteService)',
  'calls OpenRouteService for real road-network travel time and stop ordering.':
    'يستخدم OpenRouteService لحساب زمن الرحلة الحقيقي وترتيب المحطات.',
  'Internal Graph': 'الشبكة الداخلية',
  'Internal Graph (District Matrix)': 'الشبكة الداخلية (مصفوفة الأحياء)',
  "computes routes and travel time from the District Matrix instead (Dijkstra / K-shortest paths) — no external API calls, but only as accurate as the District Matrix data, and requires the new order's restaurant and destination to both fall along the captain's existing route.":
    'يحسب المسارات وزمن الرحلة من مصفوفة الأحياء (Dijkstra / أقصر K مسارات) — دون خدمات خارجية، لكن دقته بقدر دقة بيانات المصفوفة، ويتطلب أن يقع مطعم الطلب الجديد ووجهته على مسار الكابتن الحالي.',
  'Route Alternatives': 'المسارات البديلة',
  'Route Alternatives (Internal Graph)': 'المسارات البديلة (الشبكة الداخلية)',
  "How many alternative routes the Internal Graph engine considers, cheapest first, on each side of the same-direction check when deciding whether a new order extends a captain's existing trip. Keep this at 1 unless you deliberately want it higher — a materially longer alternate route can still pass the same-direction check purely on district order, before the real delivery-time check gets a chance to reject a detour that isn't actually worth it. Only applies when the Stacking Route Engine above is set to Internal Graph.":
    'عدد المسارات البديلة التي يدرسها محرك الشبكة الداخلية (الأقل تكلفة أولًا) في فحص نفس الاتجاه عند تحديد ما إذا كان الطلب الجديد يكمل رحلة الكابتن الحالية. اتركه 1 ما لم ترد غير ذلك عمدًا — فالمسار البديل الأطول قد يجتاز فحص الاتجاه بترتيب الأحياء فقط قبل أن يرفض فحص وقت التوصيل الفعلي تحويلة غير مجدية. ينطبق فقط عند ضبط محرك مسارات التجميع على الشبكة الداخلية.',
  'Travel Time Factor': 'معامل زمن الرحلة',
  'Multiplies every district-to-district travel time and distance used in dispatch and stacking — District Matrix routes, the zone sequence formula, same-district trips and the fallback estimate. 0.5 halves them (a 25-minute route counts as 12.5 minutes); 1 uses the stored values as they are. The stored District Matrix values themselves are not changed.':
    'يُضرب فيه كل زمن ومسافة بين الأحياء المستخدمة في التوزيع والتجميع — مسارات مصفوفة الأحياء، ومعادلة تسلسل المنطقة، والرحلات داخل نفس الحي، والتقدير الاحتياطي. القيمة 0.5 تقسمها على 2 (مسار مدته 25 دقيقة يُحسب 12.5 دقيقة)؛ والقيمة 1 تستخدم القيم المخزنة كما هي. لا تتغير قيم مصفوفة الأحياء المخزنة نفسها.',
  'Must be greater than 0 and at most 2': 'يجب أن يكون أكبر من 0 وبحد أقصى 2',
  'Times and distances above include the Travel Time Factor from Platform Settings. The matrix rows below show the stored values before the factor.':
    'الأزمنة والمسافات أعلاه تشمل معامل زمن الرحلة من إعدادات المنصة. صفوف المصفوفة أدناه تعرض القيم المخزنة قبل تطبيق المعامل.',
  'Stacking Distance Fallback': 'مسافة التجميع الاحتياطية',
  "The Internal Graph route engine normally requires a new order's restaurant to sit literally on the captain's existing route — this allows a restaurant within this many real graph-path km of the trip's original restaurant to stack anyway, even if it fails that strict check. Delivery-time limits still apply exactly the same either way. Leave blank to keep the strict route-only behavior.":
    'يتطلب محرك الشبكة الداخلية عادةً أن يقع مطعم الطلب الجديد على مسار الكابتن الحالي تمامًا — وهذا يسمح بالتجميع لمطعم يبعد هذا العدد من الكيلومترات (عبر مسار الشبكة) عن مطعم الرحلة الأصلي حتى لو لم يجتز الفحص الصارم. تظل حدود وقت التوصيل كما هي. اتركه فارغًا للإبقاء على السلوك الصارم.',
  'Blank = disabled': 'فارغ = معطّل',
  'Max Delivery Time for Stacking (min)': 'أقصى وقت توصيل للتجميع (دقيقة)',
  'At-Restaurant': 'في المطعم',
  'At-Restaurant Arrival Radius': 'نطاق الوصول إلى المطعم',
  'Destination Arrival Radius': 'نطاق الوصول إلى وجهة التوصيل',
  "How close a captain must be to the order's destination district before the app lets them mark it delivered: inside the district's boundary or within this many meters of it — or of the district's centre point if it has no boundary drawn. Uses the location the app sends, otherwise the captain's last heartbeat. Rejected with a 409 if they're further away.":
    'مدى قرب الكابتن من حي الوجهة قبل أن يسمح له التطبيق بتأكيد التسليم: داخل حدود الحي أو على بعد هذا العدد من الأمتار منها — أو من نقطة مركز الحي إذا لم تُرسم له حدود. يُستخدم الموقع الذي يرسله التطبيق، وإلا فآخر موقع مسجّل للكابتن. يُرفض الطلب (409) إذا كان أبعد من ذلك.',
  'How close (straight-line meters) a captain\'s reported location must be to the restaurant before the app lets them mark an order as "At Restaurant" — rejected with a 409 if they\'re further away than this.':
    'أقرب مسافة (بالمتر بخط مستقيم) يجب أن يكون فيها الكابتن من المطعم ليسمح له التطبيق بتحديد الطلب "في المطعم" — ويُرفض إذا كان أبعد من ذلك.',
  'At-Restaurant Cancellation Compensation': 'تعويض الإلغاء في المطعم',
  "Flat amount paid to the captain when an order is cancelled after they've already reached the restaurant. Always charged to the restaurant when the restaurant cancels; when Admin cancels at this stage, they choose whether the restaurant, the platform, or no one pays — but never a different amount.":
    'مبلغ ثابت يُدفع للكابتن عند إلغاء الطلب بعد وصوله للمطعم. يتحمله المطعم دائمًا إذا ألغى المطعم؛ وإذا ألغت الإدارة في هذه المرحلة تختار من يدفع: المطعم أو المنصة أو لا أحد — لكن دون تغيير المبلغ.',
  'Default Daily At-Restaurant Cancellation Limit': 'الحد اليومي الافتراضي للإلغاء في المطعم',
  'How many at-restaurant-stage cancellations a restaurant may make itself per operating shift before being blocked and directed to contact support — the platform default; an individual restaurant can be given its own limit instead on its edit page. Admin cancellations never count against this.':
    'عدد مرات الإلغاء في مرحلة الوصول للمطعم المسموح بها للمطعم في كل وردية قبل حظره وتوجيهه للتواصل مع الدعم — هذا هو الافتراضي للمنصة؛ ويمكن تحديد حد خاص لكل مطعم من صفحة تعديله. إلغاءات الإدارة لا تُحتسب.',
  'Post-Pickup Compensation Multiplier': 'مُضاعِف التعويض بعد الاستلام',
  "When Admin cancels an order that's already been picked up or delivered, any platform-funded compensation to the captain is capped at this many times that order's own commission (":
    'عندما تلغي الإدارة طلبًا تم استلامه أو توصيله، يكون أي تعويض للكابتن من المنصة بحد أقصى هذا العدد من أضعاف عمولة الطلب نفسه (',
  ') — the cap itself is the safeguard, so no separate approval step is needed on top of it.':
    ') — الحد نفسه هو الضمانة، فلا حاجة لخطوة موافقة إضافية.',
  '× request_fee': '× عمولة الطلب',
  'App Fee': 'عمولة التطبيق',
  "The platform's commission, charged from a captain's wallet to the platform wallet (":
    'عمولة المنصة، تُخصم من محفظة الكابتن لصالح محفظة المنصة (',
  ") when an order is marked delivered — a percentage of that order's": ') عند تحديد الطلب كتم توصيله — كنسبة من',
  'Example: a 30 EGP delivery fee would charge the captain': 'مثال: رسوم توصيل 30 ج.م تعني خصم',
  'on delivery.': 'من الكابتن عند التوصيل.',
  'Wallet Negative Balance Limits': 'حدود الرصيد السالب للمحافظ',
  'How far each wallet': 'إلى أي حد يمكن لكل',
  "may go below zero before a debit is refused — one number per type, not a single shared limit, since each carries a different risk. A captain's last active order shouldn't get stuck (or its commission go silently uncollected) over a thin balance; a restaurant cancelling at the at-restaurant stage always owes the standard compensation above and shouldn't be blocked from cancelling by a thin balance either; the platform's own wallet going negative is internal bookkeeping, not a real liability, so it's normally set far higher than the other two.":
    'من المحافظ أن ينزل تحت الصفر قبل رفض الخصم — رقم لكل نوع وليس حدًا مشتركًا، لأن لكل نوع مخاطرة مختلفة. لا يجب أن يتعطل آخر طلب نشط للكابتن (أو تضيع عمولته) بسبب رصيد قليل؛ والمطعم الذي يلغي في مرحلة الوصول يدين دائمًا بالتعويض القياسي ولا يجب منعه من الإلغاء بسبب رصيد قليل؛ أما محفظة المنصة فرصيدها السالب قيد داخلي وليس التزامًا حقيقيًا، لذا يُضبط حدها عادةً أعلى بكثير.',
  'Wallet Top-Up Numbers': 'أرقام شحن المحافظ',
  "Where a captain or restaurant sends money for an external wallet top-up (Vodafone Cash, InstaPay, etc.) before submitting proof of payment — shown directly on their wallet screen. A label per number (which service it's for) is required.":
    'الأرقام التي يحوّل إليها الكابتن أو المطعم المال لشحن المحفظة خارجيًا (فودافون كاش، إنستاباي، إلخ) قبل إرسال إثبات الدفع — تظهر مباشرة في شاشة المحفظة. يجب إدخال وصف لكل رقم (الخدمة الخاصة به).',
  'e.g. Vodafone Cash': 'مثال: فودافون كاش',
  'No top-up numbers configured yet.': 'لم يتم إعداد أرقام شحن بعد.',
  'Minimum Top-Up Amount': 'الحد الأدنى لشحن الرصيد',
  'The smallest amount a captain, restaurant or brand can submit in one top-up request. Your own direct top-ups are not limited.':
    'أقل مبلغ يمكن للكابتن أو المطعم أو العلامة التجارية إرساله في طلب شحن واحد. لا ينطبق هذا على الشحن المباشر الذي تقوم به بنفسك.',

  // ---------------------------------------------------------------- content / notifications / ratings
  "The landing page offers the release marked Current for each app (captain, restaurant). New uploads — from here or from CI — aren't shown until you set them as current, except an app's first release. At most 5 releases are kept per app: uploading more removes the oldest one that isn't current. Deleting the current release makes the newest remaining one current.":
    'تعرض الصفحة الرئيسية الإصدار المحدد كـ "الحالي" لكل تطبيق (الكابتن، المطعم). الملفات الجديدة — من هنا أو من CI — لا تظهر حتى تحددها كإصدار حالي، باستثناء أول إصدار للتطبيق. يُحتفظ بـ 5 إصدارات كحد أقصى لكل تطبيق: رفع المزيد يحذف أقدم إصدار غير حالي. حذف الإصدار الحالي يجعل أحدث إصدار متبقٍ هو الحالي.',
  'Landing page': 'الصفحة الرئيسية',
  Current: 'الحالي',
  'Set as current': 'تعيين كإصدار حالي',
  '{count} of 5': '{count} من 5',
  "Uploaded — it's this app's first release, so it's shown on the landing page.":
    'تم الرفع — هذا أول إصدار للتطبيق، لذلك يظهر في الصفحة الرئيسية.',
  'Uploaded. It is not on the landing page until you set it as current.': 'تم الرفع. لن يظهر في الصفحة الرئيسية حتى تحدده كإصدار حالي.',
  '{count} oldest release(s) removed — at most 5 are kept per app.': 'تم حذف {count} من أقدم الإصدارات — يُحتفظ بـ 5 كحد أقصى لكل تطبيق.',
  '{label} is now shown on the landing page.': 'يظهر {label} الآن في الصفحة الرئيسية.',
  'App versions': 'إصدارات التطبيق',
  'Earlier APKs': 'ملفات APK السابقة',
  'Uploaded before app versions, so they have no version.': 'رُفعت قبل إضافة إصدارات التطبيق، لذلك ليس لها إصدار.',
  'Show APK': 'عرض ملف APK',
  'iOS versions have no APK': 'إصدارات iOS ليس لها ملف APK',
  'Each version has its own key and secret. Create the version first, build the app with them, then upload the APK with the same label.':
    'لكل إصدار مفتاح وسر خاصان به. أنشئ الإصدار أولًا، ثم ابنِ التطبيق بهما، ثم ارفع ملف APK بنفس الاسم.',
  'New version': 'إصدار جديد',
  Platform: 'المنصة',
  Key: 'المفتاح',
  APK: 'APK',
  'Last used': 'آخر استخدام',
  'Force update': 'فرض التحديث',
  'No app versions yet': 'لا توجد إصدارات للتطبيق بعد',
  'APK uploaded': 'تم الرفع',
  'Not yet': 'ليس بعد',
  Create: 'إنشاء',
  'Captain app': 'تطبيق الكابتن',
  'Restaurant app': 'تطبيق المطعم',
  "Copy these now — the secret won't be shown again. Build this version of the app with them.":
    'انسخهما الآن — لن يُعرض السر مرة أخرى. ابنِ هذا الإصدار من التطبيق بهما.',
  'Turn off force update?': 'إيقاف فرض التحديث؟',
  'Force this version to update?': 'فرض التحديث على هذا الإصدار؟',
  'This version can get a token and work normally again.': 'سيتمكن هذا الإصدار من الحصول على رمز والعمل بشكل طبيعي مرة أخرى.',
  '“{label}” stops getting a token and shows the update screen. A running app continues until its token expires, up to 1 hour.':
    'لن يحصل "{label}" على رمز وستظهر شاشة التحديث. يستمر التطبيق المفتوح حتى تنتهي صلاحية رمزه، خلال ساعة كحد أقصى.',
  'Turn off': 'إيقاف',
  'App Links': 'روابط التطبيقات',
  'Where a force-updated app version is sent, usually its store page. A version can only be forced once its link is set.':
    'الرابط الذي يُوجَّه إليه الإصدار عند فرض التحديث، وعادةً ما يكون صفحة المتجر. لا يمكن فرض التحديث على إصدار قبل تعيين رابطه.',
  'Captain app — Android': 'تطبيق الكابتن — Android',
  'Captain app — iOS': 'تطبيق الكابتن — iOS',
  'Restaurant app — Android': 'تطبيق المطعم — Android',
  'Restaurant app — iOS': 'تطبيق المطعم — iOS',
  'Must be a link starting with http:// or https://': 'يجب أن يكون رابطًا يبدأ بـ http:// أو https://',
  'CI upload key': 'مفتاح الرفع من CI',
  'Active key ending in …{hint} · created {created} by {name} · last used {used}':
    'المفتاح النشط ينتهي بـ …{hint} · أُنشئ {created} بواسطة {name} · آخر استخدام {used}',
  never: 'أبدًا',
  'No key — uploads from CI are off. Generate one and save it as a secret in your CI (APP_RELEASE_UPLOAD_KEY).':
    'لا يوجد مفتاح — الرفع من CI متوقف. أنشئ مفتاحًا واحفظه كسر في CI باسم APP_RELEASE_UPLOAD_KEY.',
  Regenerate: 'إنشاء مفتاح جديد',
  Revoke: 'إلغاء',
  'Generate key': 'إنشاء مفتاح',
  'Revoke the upload key?': 'إلغاء مفتاح الرفع؟',
  'Regenerate the upload key?': 'إنشاء مفتاح رفع جديد؟',
  'CI uploads stop working until you generate a new key.': 'يتوقف الرفع من CI حتى تنشئ مفتاحًا جديدًا.',
  'The current key stops working immediately — update the secret in your CI with the new one.':
    'يتوقف المفتاح الحالي فورًا — حدّث السر في CI بالمفتاح الجديد.',
  'New upload key': 'مفتاح الرفع الجديد',
  "Copy it now — it won't be shown again. Save it in your CI as the secret APP_RELEASE_UPLOAD_KEY.":
    'انسخه الآن — لن يُعرض مرة أخرى. احفظه في CI كسر باسم APP_RELEASE_UPLOAD_KEY.',
  Copy: 'نسخ',
  Copied: 'تم النسخ',
  Done: 'تم',
  'Upload APK': 'رفع APK',
  'Choose .apk file': 'اختر ملف ‎.apk',
  'Choose another file': 'اختر ملفًا آخر',
  'Pick an .apk file': 'اختر ملف ‎.apk',
  'e.g. Captain v1.4.0': 'مثال: Captain v1.4.0',
  "Shown on the landing page's download button": 'يظهر على زر التحميل في الصفحة الرئيسية',
  'No APKs uploaded yet': 'لم يتم رفع ملفات APK بعد',
  'Delete this APK?': 'حذف ملف APK هذا؟',
  "” and its file will be deleted. If it's the current release, the newest remaining one takes its place on the landing page. This can't be undone.":
    '” سيُحذف مع ملفه. إذا كان الإصدار الحالي، يحل محله أحدث إصدار متبقٍ في الصفحة الرئيسية. لا يمكن التراجع عن ذلك.',
  'Send Notification': 'إرسال إشعار',
  'Rated Entity ID': 'معرّف الجهة المُقيَّمة',

  // ---------------------------------------------------------------- toast messages
  'Password reset for {name}': 'تمت إعادة تعيين كلمة المرور لـ {name}',
  'Wallet #{id} topped up': 'تم شحن المحفظة #{id}',
  'Adjustment applied to wallet #{id}': 'تم تطبيق التسوية على المحفظة #{id}',
  "Approved — {amount} EGP added to {name}'s wallet, {type} notified":
    'تم القبول — أُضيف {amount} ج.م إلى محفظة {name}، وتم إشعار ({type})',
  'Cancelled top-up request for {name}, {type} notified': 'تم إلغاء طلب الشحن لـ {name}، وتم إشعار ({type})',
  '{name} verified — {type} account created': 'تم توثيق {name} — وإنشاء حساب ({type})',
  'Rejected registration request for {name}': 'تم رفض طلب تسجيل {name}',
  'Order #{id} marked as {state}': 'تم تحديد الطلب #{id} كـ {state}',
  'Mark Delivered': 'تأكيد التسليم',
  'Mark Order #{id} as Delivered': 'تأكيد تسليم الطلب #{id}',
  'Order #{id} marked as delivered': 'تم تأكيد تسليم الطلب #{id}',
  'Failed to mark the order delivered': 'تعذّر تأكيد تسليم الطلب',
  "Use this when the captain can't confirm delivery from the app — for example the customer changed their location. The destination arrival check is skipped, the captain is notified, and the order history records you and the reason.":
    'استخدم هذا عندما لا يستطيع الكابتن تأكيد التسليم من التطبيق — مثلًا إذا غيّر العميل موقعه. يتم تجاوز التحقق من الوصول إلى الوجهة، ويُبلَّغ الكابتن، ويُسجَّل في سجل الطلب اسمك والسبب.',
  'Approved bundle request for {name}': 'تم قبول طلب الباقة لـ {name}',
  'Rejected bundle request for {name}': 'تم رفض طلب الباقة لـ {name}',
  'Fees uploaded — {inserted} added, {updated} updated': 'تم رفع الرسوم — أُضيف {inserted} وحُدّث {updated}',
  order: 'طلب',
  trip: 'رحلة',
  orders: 'طلب',
  wallet_topup_request: 'طلب شحن رصيد',
  bundle_subscription: 'اشتراك باقة',
  manual_topup: 'شحن يدوي',
  restaurant_subscriptions: 'اشتراك باقة',

  // ---------------------------------------------------------------- misc
  'Active Drivers': 'الكباتن النشطون',
  Admin: 'الإدارة',
  Assignment: 'التعيين',
  Deliveries: 'التوصيلات',
  'Reject Request': 'رفض الطلب',
  'Search by district name…': 'ابحث باسم الحي…',
  'Search by name…': 'ابحث بالاسم…',
  'Search for a place name…': 'ابحث عن اسم مكان…',
  'No matches found for that name': 'لا توجد نتائج لهذا الاسم',
  'Search by name to locate it on the map, then fine-tune by clicking or dragging the pin.':
    'ابحث بالاسم لتحديد الموقع على الخريطة، ثم اضبطه بالنقر أو بسحب العلامة.',

  // ---------------------------------------------------------------- DB enum values (shown via t(value))
  // order statuses
  created: 'تم الإنشاء',
  assigned: 'تم التعيين',
  accepted: 'مقبول',
  picked_up: 'تم الاستلام',
  delivered: 'تم التوصيل',
  cancelled: 'ملغي',
  hold: 'معلّق',
  at_restaurant: 'في المطعم',
  reassigned: 'أُعيد تعيينه',
  // captain statuses
  ready: 'جاهز',
  in_progress: 'في رحلة',
  busy: 'مشغول',
  not_ready: 'غير جاهز',
  disabled: 'معطّل',
  requesting: 'يطلب',
  // generic statuses
  pending: 'قيد الانتظار',
  approved: 'مقبول',
  rejected: 'مرفوض',
  superseded: 'مُستبدل',
  completed: 'مكتمل',
  active: 'نشط',
  inactive: 'غير نشط',
  suspended: 'موقوف',
  timeout: 'انتهت المهلة',
  system_skip: 'تخطٍ تلقائي',
  // actor / owner types
  admin: 'الإدارة',
  restaurant: 'مطعم',
  captain: 'كابتن',
  system: 'النظام',
  platform: 'المنصة',
  restaurant_brand: 'علامة تجارية',
  // roles
  super_admin: 'مدير عام',
  operations: 'العمليات',
  support: 'الدعم',
  dispatcher: 'موزّع الطلبات',
  // dispatch / modes
  admin_pool: 'مجمع الإدارة',
  bundle: 'باقة',
  dedicated: 'مخصص',
  shared: 'مشترك',
  // wallet transactions
  credit: 'إضافة',
  debit: 'خصم',
  top_up: 'شحن رصيد',
  bonus: 'مكافأة',
  request_fee: 'عمولة الطلب',
  delivery_fee: 'رسوم التوصيل',
  voucher_installment: 'قسط قسيمة',
  subscription_payment: 'دفع اشتراك',
  refund: 'استرداد',
  adjustment: 'تسوية',
  cancellation_compensation: 'تعويض إلغاء',
  // vehicles
  motorcycle: 'موتوسيكل',
  bicycle: 'دراجة',
  car: 'سيارة',
  // travel-time sources
  zone_sequence: 'تسلسل المنطقة',
  matrix: 'المصفوفة',
  estimated: 'تقديري',
  same_district: 'نفس الحي',

  // ---- restaurant-owned bundles (migration 076) ----
  Shared: 'مشتركة',
  'Fixed Captains': 'الكباتن الثابتون',
  'Waive Cancellation Fees': 'إعفاء من رسوم الإلغاء',
  'Waive cancellation fees (no compensation is paid)': 'إعفاء من رسوم الإلغاء (لا يُدفع أي تعويض)',
  'Order Flow': 'مسار الطلب',
  'Copy to Restaurant': 'نسخ إلى مطعم',
  'Order flow saved': 'تم حفظ مسار الطلب',
  '{name} is now a fixed captain': '{name} أصبح كابتنًا ثابتًا',
  '{name} is no longer a fixed captain': '{name} لم يعد كابتنًا ثابتًا',
  'Bundle copied, but the subscription request failed: {reason}': 'تم نسخ الباقة، لكن فشل طلب الاشتراك: {reason}',
  'Bundle copied to {name} — its request is waiting on Bundle Requests': 'تم نسخ الباقة إلى {name} — طلبها بانتظار المراجعة في طلبات الباقات',
  'Bundle copied to {name}': 'تم نسخ الباقة إلى {name}',
  'Order Flow — {name}': 'مسار الطلب — {name}',
  'Captain confirms "arrived at restaurant" before pickup': 'يؤكد الكابتن "الوصول إلى المطعم" قبل الاستلام',
  'Flow: accepted → at restaurant → picked up → delivered': 'المسار: مقبول ← في المطعم ← تم الاستلام ← تم التوصيل',
  'Flow: accepted → picked up → delivered': 'المسار: مقبول ← تم الاستلام ← تم التوصيل',
  'Order status': 'حالة الطلب',
  'Restaurant can cancel': 'يمكن للمطعم الإلغاء',
  'Captain can cancel': 'يمكن للكابتن الإلغاء',
  'New order': 'طلب جديد',
  'On hold (no captain yet)': 'معلّق (لا يوجد كابتن بعد)',
  'Offered to a captain': 'معروض على كابتن',
  'Accepted by the captain': 'قبله الكابتن',
  'Captain at the restaurant': 'الكابتن في المطعم',
  'Picked up by the captain': 'استلمه الكابتن',
  'Changes apply to new orders. Orders already placed keep the rules they were created with.':
    'تُطبّق التغييرات على الطلبات الجديدة. الطلبات الحالية تحتفظ بالقواعد التي أُنشئت بها.',
  'Fixed Captains — {name}': 'الكباتن الثابتون — {name}',
  'Fixed captains only receive this restaurant’s orders while its bundle is active, and its orders try them first. Capacity they leave free is filled from the pool.':
    'الكباتن الثابتون يستلمون طلبات هذا المطعم فقط طالما باقته نشطة، وتُعرض طلباته عليهم أولًا. السعة المتبقية بعدهم تُملأ من الكباتن العامين.',
  '{fixed} fixed of {max} captains (plus any extra captains on the subscription)': '{fixed} ثابت من {max} كباتن (بالإضافة لأي كباتن إضافيين في الاشتراك)',
  'Add a captain': 'إضافة كابتن',
  'No fixed captains yet': 'لا يوجد كباتن ثابتون بعد',
  'Copy “{name}” to a restaurant': 'نسخ "{name}" إلى مطعم',
  'Copies the bundle’s settings, order flow and fee waiver — not its fixed captains. Only restaurants with no bundle are listed.':
    'ينسخ إعدادات الباقة ومسار الطلب والإعفاء من الرسوم — دون الكباتن الثابتين. تظهر فقط المطاعم التي ليس لديها باقة.',
  'Also create the subscription request (approve it on Bundle Requests)': 'إنشاء طلب الاشتراك أيضًا (تتم الموافقة عليه في طلبات الباقات)',
  'own bundle': 'باقة خاصة',
  'Expires At': 'تاريخ الانتهاء',
  extra: 'إضافي',
  fixed: 'ثابت',
  Extend: 'تمديد',
  'Bundle extended': 'تم تمديد الباقة',
  'Extension failed': 'فشل التمديد',
  'Expires on': 'تنتهي في',
  'Extra captains (total)': 'الكباتن الإضافيون (الإجمالي)',
  'Extra captains are added to the bundle’s capacity until the subscription expires.': 'يُضاف الكباتن الإضافيون إلى سعة الباقة حتى انتهاء الاشتراك.',
  // bundle details page
  View: 'عرض',
  Subscriptions: 'الاشتراكات',
  '{count} captains': '{count} كباتن',
  'Bundle updated successfully': 'تم تحديث الباقة بنجاح',
  'Delete the bundle “{name}”? This cannot be undone.': 'حذف الباقة "{name}"؟ لا يمكن التراجع عن ذلك.',
  'View bundle': 'عرض الباقة',
  'Approve bundle request': 'الموافقة على طلب الباقة',
  'Approving charges the restaurant the bundle price.': 'الموافقة تخصم سعر الباقة من محفظة المطعم.',
  'Extend subscription': 'تمديد الاشتراك',
  'Capacity: {base} + {extra} extra = {total} captains': 'السعة: {base} + {extra} إضافي = {total} كباتن',
  'Current subscription': 'الاشتراك الحالي',
  'Waiting for approval': 'بانتظار الموافقة',
  // Subscriptions list/detail and pauses (migration 078)
  Subscription: 'الاشتراك',
  Paused: 'موقوف',
  'Paused until': 'موقوف حتى',
  'Paused from': 'موقوف من',
  'Extra captains': 'كباتن إضافيون',
  'Pause subscription': 'إيقاف الاشتراك مؤقتًا',
  'Pause for (hours)': 'مدة الإيقاف (بالساعات)',
  'New subscription': 'اشتراك جديد',
  Scheduled: 'مجدول',
  'Start failed': 'تعذر البدء',
  'Starts on': 'يبدأ في',
  'Expires around {date}': 'ينتهي تقريبًا في {date}',
  'Subscription scheduled': 'تمت جدولة الاشتراك',
  'Subscription started': 'بدأ الاشتراك',
  'Scheduled subscription cancelled': 'تم إلغاء الاشتراك المجدول',
  'Cancel subscription': 'إلغاء الاشتراك',
  'Renewed automatically': 'تجديد تلقائي',
  'Restaurants with their own bundle and nothing scheduled are listed.': 'تظهر هنا المطاعم التي لها باقة خاصة وليس لها اشتراك مجدول.',
  '{price} EGP for {days} days · {count} captains': '{price} ج.م لمدة {days} يوم · {count} كباتن',
  "The current subscription runs until this date, so this one can't start earlier.": 'الاشتراك الحالي مستمر حتى هذا التاريخ، لذا لا يمكن أن يبدأ هذا الاشتراك قبله.',
  'Starting now charges the restaurant the full price. The wallet must hold all of it.': 'البدء الآن يخصم السعر كاملًا من المطعم، ويجب أن تحتوي المحفظة على المبلغ كاملًا.',
  'The restaurant is charged on the start date, not now. If the wallet is short then, it waits and starts once the wallet can pay.':
    'يتم الخصم من المطعم في تاريخ البدء وليس الآن. إذا لم يكفِ الرصيد حينها، ينتظر الاشتراك ويبدأ عندما يكفي الرصيد.',
  'This subscription couldn’t start, usually because the wallet doesn’t hold the full price. The restaurant can’t create orders until it does. It keeps trying and starts by itself.':
    'تعذر بدء هذا الاشتراك، وغالبًا لأن رصيد المحفظة لا يغطي السعر كاملًا. لا يمكن للمطعم إنشاء طلبات حتى يبدأ. تستمر المحاولة وسيبدأ تلقائيًا.',
  'The next subscription couldn’t start, usually because the wallet is short. It starts by itself once the wallet can pay.':
    'تعذر بدء الاشتراك التالي، وغالبًا لأن رصيد المحفظة غير كافٍ. سيبدأ تلقائيًا عندما يكفي الرصيد.',
  'The next subscription starts on {date}. The wallet is charged then.': 'يبدأ الاشتراك التالي في {date}، ويتم الخصم من المحفظة حينها.',
  'Extend the expiry or add extra captains from the subscription’s page.': 'يمكنك تمديد الانتهاء أو إضافة كباتن إضافيين من صفحة الاشتراك.',
  'Price per period (EGP)': 'السعر لكل فترة (ج.م)',
  'Duration (days)': 'المدة (بالأيام)',
  Duration: 'المدة',
  'End now': 'إنهاء الآن',
  'This bundle has no subscriptions yet.': 'لا توجد اشتراكات لهذه الباقة بعد.',
  'Current subscription': 'الاشتراك الحالي',
  'Last subscription': 'آخر اشتراك',
  'Extend it or add extra captains from the subscription’s page.': 'يمكنك تمديده أو إضافة كباتن إضافيين من صفحة الاشتراك.',
  'This restaurant has had no subscription yet.': 'لم يكن لهذا المطعم أي اشتراك بعد.',
  'Extended until': 'ممدد حتى',
  'Paid until {date}. This date stays as it is.': 'مدفوع حتى {date}. يبقى هذا التاريخ كما هو.',
  'End subscription': 'إنهاء الاشتراك',
  'Subscription ended': 'تم إنهاء الاشتراك',
  'View subscription': 'عرض الاشتراك',
  'This ends it now with no refund. {days} paid day(s) will be lost.': 'سيتم الإنهاء الآن بدون استرداد. ستُفقد {days} يوم/أيام مدفوعة.',
  'The restaurant can’t create orders until a new subscription starts.': 'لا يمكن للمطعم إنشاء طلبات حتى يبدأ اشتراك جديد.',
  'A scheduled subscription for this restaurant is cancelled too.': 'سيتم أيضًا إلغاء أي اشتراك مجدول لهذا المطعم.',
  'The running subscription is still on {bundle}. {own} takes over when a new subscription starts.': 'الاشتراك الجاري ما زال على {bundle}. ستحل {own} محلها عند بدء اشتراك جديد.',
  'To unassign this bundle, first end its running subscription or cancel its scheduled one.': 'لإلغاء تعيين هذه الباقة، قم أولًا بإنهاء اشتراكها الجاري أو إلغاء اشتراكها المجدول.',
  Price: 'السعر',
  Weekly: 'أسبوعي',
  Monthly: 'شهري',
  'Auto-renew': 'تجديد تلقائي',
  'Auto-renew (start the next subscription when this one expires)': 'تجديد تلقائي (يبدأ الاشتراك التالي عند انتهاء الحالي)',
  '{days} days': '{days} يوم',
  Continue: 'متابعة',
  '{price} EGP · {count} captains': '{price} جنيه · {count} كباتن',
  'Restaurants with their own bundle and no pending request are listed.': 'تظهر المطاعم التي لديها باقة خاصة بها وليس لديها طلب معلّق.',
  'This restaurant already has a current subscription — approving the new one replaces it.': 'لدى هذا المطعم اشتراك حالي بالفعل — الموافقة على الاشتراك الجديد تستبدله.',
  'Next you set the expiry and approve it, which charges the restaurant the bundle price. If you close that step, the request stays pending.': 'بعد ذلك تحدد تاريخ الانتهاء وتوافق عليه، مما يخصم سعر الباقة من المطعم. إذا أغلقت هذه الخطوة يبقى الطلب معلّقًا.',
  'Reason (optional)': 'السبب (اختياري)',
  Pause: 'إيقاف مؤقت',
  Resume: 'استئناف',
  'Resume now': 'استئناف الآن',
  'Subscription paused': 'تم إيقاف الاشتراك مؤقتًا',
  'Pause failed': 'تعذّر إيقاف الاشتراك',
  'Subscription resumed': 'تم استئناف الاشتراك',
  'Pause history': 'سجل الإيقاف',
  Ended: 'انتهى',
  Running: 'جارٍ',
  'Ended on its own': 'انتهى تلقائيًا',
  'Resumed {date} by {name}': 'استُؤنف {date} بواسطة {name}',
  'This subscription has never been paused.': 'لم يتم إيقاف هذا الاشتراك من قبل.',
  'Price paid': 'المبلغ المدفوع',
  'Charge the wallet': 'خصم قيمة الاشتراك من المحفظة',
  'On the start date': 'في تاريخ البدء',
  'On the expiry date': 'في تاريخ الانتهاء',
  '{amount} EGP unpaid': '{amount} جنيه غير مدفوعة',
  '{amount} EGP due on {date}': '{amount} جنيه مستحقة في {date}',
  'The next subscription starts on {date}. The wallet is charged on its expiry date.': 'يبدأ الاشتراك التالي في {date}، ويتم الخصم من المحفظة في تاريخ انتهائه.',
  'The wallet couldn’t pay {amount} EGP for this subscription. No new subscription can start for this restaurant until it’s paid. It keeps trying and is charged by itself once the wallet can pay.': 'تعذر خصم {amount} جنيه من المحفظة لهذا الاشتراك. لا يمكن بدء اشتراك جديد لهذا المطعم حتى يتم السداد، وتستمر المحاولة ويتم الخصم تلقائيًا عند توفر الرصيد.',
  'Subscription #{id} is unpaid ({amount} EGP). Nothing new can start until the wallet has paid it.': 'الاشتراك رقم {id} غير مدفوع ({amount} جنيه). لا يمكن بدء اشتراك جديد حتى يتم سداده من المحفظة.',
  'The restaurant is charged on the expiry date, not now. If the wallet is short then, the subscription is unpaid and no new one starts until it’s paid.': 'يتم الخصم من المطعم في تاريخ الانتهاء وليس الآن. إذا لم يكفِ الرصيد حينها يصبح الاشتراك غير مدفوع ولا يبدأ اشتراك جديد حتى يتم السداد.',
  'This ends it now. The {amount} EGP isn’t charged, and the subscription stays unpaid.': 'سيتم الإنهاء الآن بدون خصم مبلغ {amount} جنيه، ويظل الاشتراك غير مدفوع.',
  'This subscription was ended before its expiry date, so {amount} EGP was never charged. It stays unpaid unless you charge it, which you can do from that date on.': 'تم إنهاء هذا الاشتراك قبل تاريخ انتهائه، لذلك لم يتم خصم {amount} جنيه. يظل غير مدفوع ما لم تقم بخصمه، ويمكنك ذلك ابتداءً من ذلك التاريخ.',
  'Charge now': 'خصم الآن',
  'Subscription charged': 'تم خصم الاشتراك',
  'This takes {amount} EGP from the restaurant’s wallet now. The wallet must hold all of it.': 'سيتم خصم {amount} جنيه من محفظة المطعم الآن، ويجب أن تحتوي المحفظة على المبلغ كاملًا.',
  Reviewed: 'تمت المراجعة',
  'View subscription': 'عرض الاشتراك',
  'Subscription not found': 'الاشتراك غير موجود',
  'Paused until {date} — the restaurant can’t create orders until then.': 'موقوف حتى {date} — لا يمكن للمطعم إنشاء طلبات حتى ذلك الحين.',
  'Paused until {date}. The restaurant can’t create orders until then; the expiry date doesn’t change.':
    'موقوف حتى {date}. لا يمكن للمطعم إنشاء طلبات حتى ذلك الحين، ولا يتغير تاريخ الانتهاء.',
  'The pause can’t end after the subscription expires ({date}).': 'لا يمكن أن ينتهي الإيقاف بعد انتهاء الاشتراك ({date}).',
  'Subscribe {name}': 'اشتراك {name}',
  'A request was made on {date}. Approving it charges the restaurant and sets the expiry.': 'تم تقديم طلب في {date}. الموافقة عليه تخصم السعر من المطعم وتحدد تاريخ الانتهاء.',
  '{name} has no active subscription to this bundle — its orders can’t be placed until it has one.': 'لا يوجد لـ {name} اشتراك نشط في هذه الباقة — لا يمكن إنشاء طلباته حتى يتوفر اشتراك.',
  'Every subscription period of this bundle, newest first.': 'كل فترات الاشتراك في هذه الباقة، الأحدث أولًا.',
  'Assign to restaurant (optional)': 'تخصيص لمطعم (اختياري)',
  'Not assigned yet': 'غير مخصصة بعد',
  'Bundle assigned to {name}': 'تم تخصيص الباقة لـ {name}',
  'Bundle unassigned': 'تم إلغاء تخصيص الباقة',
  Unassign: 'إلغاء التخصيص',
  Assign: 'تخصيص',
  'This is a shared bundle from before: {count} restaurant(s) still use it until their subscriptions end. It can’t be assigned — copy it to a restaurant instead.': 'هذه باقة مشتركة قديمة: لا يزال {count} مطعم يستخدمها حتى تنتهي اشتراكاتهم. لا يمكن تخصيصها — انسخها إلى مطعم بدلًا من ذلك.',
  'Assign to a restaurant': 'تخصيص لمطعم',
  'Only restaurants without a bundle are listed.': 'تظهر فقط المطاعم التي ليس لديها باقة.',
  'Assign this bundle to a restaurant first (above the tabs).': 'خصّص هذه الباقة لمطعم أولًا (أعلى التبويبات).',
  'This restaurant has no bundle. Bundles are assigned to a restaurant from the bundle’s page.': 'لا توجد باقة لهذا المطعم. يتم تخصيص الباقات للمطاعم من صفحة الباقة.',
  'Go to Bundles': 'الذهاب إلى الباقات',
  'No active subscription': 'لا يوجد اشتراك نشط',
  'Approve, extend the expiry or add extra captains from the bundle’s page.': 'الموافقة وتمديد الصلاحية وإضافة كباتن إضافيين تتم من صفحة الباقة.'
};

export default ar;
